// import {
//     IonText, useIonAlert, IonInput, IonRow, IonCol, IonLabel, IonButton,
//     IonGrid, IonSelect, IonSelectOption, IonImg, IonIcon, IonPage,
//     IonContent, IonItemDivider, IonLoading, IonSlides, IonSlide, IonPopover, IonList, IonCard, IonHeader,
//     IonAccordionGroup,
//     IonAccordion,
//     IonItem,
//     IonRadioGroup,
//     IonRadio
// } from '@ionic/react'
// import React, { useEffect, useRef, useState } from "react";
// import { informationCircle, arrowBack, key, ellipsisVerticalCircleOutline, close, informationCircleSharp, checkmarkCircleSharp, shareSocialOutline, shareSocialSharp, chevronDownOutline, gridOutline, listOutline } from "ionicons/icons"
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';
// import { Modal } from 'react-bootstrap'
// import 'bootstrap/dist/js/bootstrap.js';
// import 'bootstrap/dist/js/bootstrap.min.js';
// import Authservice from "../Services/auth.service";
// import UserHead from "./UserHead";
// import Foot from "./Foot";
// import "jquery/dist/jquery.min.js"
// import { useHistory } from "react-router";
// import "./sam-temp.css"
// import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';
// import { useForm } from "react-hook-form";
// import Lightbox from "react-image-lightbox";
// import "react-image-lightbox/style.css";
// import { Capacitor } from '@capacitor/core';
// import CustomSpin from '../components/customSpin';
// import Select, { components } from 'react-select';
// import UserService from '../Services/user.service';
// import { closeicon, infoicon, shareIcon, tick } from '../theme/imagePath';
// import HeadFoot from './Head';
// import Breadcrumb from '../components/Breadcrumb';
// import { searchOutline } from 'ionicons/icons';  // Import the search icon
// import DataTable from 'react-data-table-component';
// import customTableStyle from '../components/CustomTableStyle';
// import CommonDataTable from '../components/datatable';
// import TempleAddEdit from './admin/templeAddEdit';
// import TempleComponent from './admin/templedetailscomponent';
// import CommonModal from '../components/popipInfo';
// import { arrowUpCircle, arrowDownCircle } from 'ionicons/icons';



// interface Props {
//     id1: string;
//     deity: string;
//     img: string;
// }
// const Temples: React.FC = () => {
//     const userdata: any = useState(sessionStorage.getItem("UserData"));
//     const uFlag: any = useState(sessionStorage.getItem("uFlag"));
//     const [userId]: any = useState(sessionStorage.getItem("UserId"));
//     const token: any = useState(sessionStorage.getItem("token"));
//     const userID: any = useState(sessionStorage.getItem("UserId"));

//     const [errorText, setErrorText] = useState("")
//     const [TempleList, setTempleList] = useState([]);
//     const [image, setImage] = useState("");
//     const [description, setDescription] = useState("");
//     const [isShow, setIsshow] = useState(false);
//     const [islogin, Islogin] = useState(false)
//     // const [index, setIndex]: any = useState(0)
//     const [showLoading, setShowLoading] = useState(false);
//     // const [id, setId] = useState("");
//     const [name, setName] = useState("");
//     const [states, setStates]: any = useState([]);
//     const history = useHistory()
//     // var randomColor = require('randomcolor');
//     const [hideContent, setHideContent] = useState(false)
//     const [index1, setIndex1] = useState(0);
//     const [Alert] = useIonAlert();
//     const [usertoken] = useState(sessionStorage.getItem("token"));
//     const [state, setState]: any = useState();
//     const [country, setCountry] = useState("India");
//     const [district, setDistrict]: any = useState()
//     const [town, setTown]: any = useState()
//     const [temName, setTemName]: any = useState()
//     const [deityId, setDeityId] = useState("");
//     const [deityName, setDeityName] = useState("");
//     const [deityImg, setDeityImg] = useState('');
//     const [gods, setGods] = useState([])
//     const [id, setId] = useState("");
//     const [facilities, setFacilities]: any = useState("");
//     const [aerial, setAerial]: any = useState([]);
//     const [Offerings, setOfferings]: any = useState([]);
//     const [festival, setFestival]: any = useState("");
//     const [poojaoffer, setpoojaoffer]: any = useState("");
//     const [timings, setTimings]: any = useState([]);
//     const [gallery, setGallery]: any = useState([]);
//     const [shop, setShopIn]: any = useState([]);
//     const [acces, setAccIn]: any = useState([]);
//     const [lat, setLat]: any = useState();
//     const [long, setLong]: any = useState();
//     const [morning, setMorning] = useState("");
//     const [evening, setEvening] = useState("");
//     const [timerequ, setTimerequ] = useState("");
//     const [closetime, setClosetime] = useState("");
//     const [entry, setEntry] = useState("");
//     const [dressme, setDressme] = useState("");
//     const [dresswo, setDresswo] = useState("");
//     const [videolink, setVideolink]: any = useState([])
//     const [videolivelink, setVideoLivelink]: any = useState([])
//     const [nodata, setNodata] = useState(false)
//     const [nodataFest, setNodataFest] = useState(false)
//     const [indexOfImages, setIndexOfImages]: any = useState("");
//     const [showModal, setShowModal] = useState(false);
//     const [showgod, setShowgod] = useState(false);
//     const openModalAndSetIndex = (index: any) => {
//         setIndexOfImages(index);
//         setShowModal(true);
//     };
//     const [stateOption, setStateOption]: any = useState([]);
//     const [districtOption, setDistrictOption]: any = useState({ value: "ALL", label: "ALL" });
//     const [districts, setDistricts]: any = useState([])
//     const [districtMenu, setDistrictMenu]: any = useState(false)
//     const [stateMenu, setStateMenu]: any = useState(false)
//     const [countries, setCountries] = useState(["India"])
//     const [countryOption, setCountryOption]: any = useState({ value: "India", label: "India" });
//     const [formErrors, setFormErrors]: any = useState({})
//     const [searchTerm, setSearchTerm] = useState('');
//     const [totalNumersOfList, setTotalNumersOfList]: any = useState(0)
//     const [additionalOption, setAdditionalOption]: any = useState({ value: "ALL", label: "ALL" })
//     const [additionalOptions, setadditionalOptions] = useState([])

//     let debounceTimeout: any;

//     const [Commonmodal, setCommonmodal] = useState(false)
//     const [CommonModalMesg, setCommonModalMesg] = useState("")
//     const [Commmonmodaltitle, setCommonmodaltitle] = useState("")





//     /*V2 changes*/
//     const [selectedOption, setSelectedOption] = useState<string>('all');
//     const Tab_items: any = [
//         "Summary",
//         "About & History",
//         "Location",
//         "Facilities & Dress Code",
//         "Time Of Worship",
//         "Pooja Offerings",
//         "Festivals",
//         "Structures & Carvings",
//         "Review",
//         "Administration"
//     ]

//     const filterOptions = [
//         { value: 'ALL', label: 'All' },
//         { value: 'deity', label: 'Deity Name' },
//         { value: 'temple', label: 'Temple Name' },
//         { value: 'offering', label: 'Offering Name' },
//     ];
//     const [searchValue, setsearchValue]: any = useState("")
//     const inputRef: any = useRef(null)


//     const columns: any = [
//         {
//             name: "Code",
//             selector: (item: any, i: any) => item.templeCode,
//             sortable: true,
//             width: "130px",
//             cell: (item: any) => (
//                 <div >
//                     <div style={{ cursor: "pointer" }} onClick={() => templeDetails(item)}>{item.templeCode}</div>
//                 </div>
//             )
//         },
//         {
//             name: "Name",
//             selector: (item: any) => item.templeName,
//             sortable: true,
//             width: "400px",
//             cell: (item: any) => (
//                 <div >
//                     <div style={{ cursor: "pointer" }} title={item.templeName} onClick={() => templeDetails(item)} >{item.templeName}</div>
//                 </div>
//             )
//         },
//         {
//             name: "Location",
//             selector: (item: any) => item.templeLocation,
//             sortable: true,
//             // width: "200px",
//             cell: (item: any) => (
//                 <div >
//                     <div style={{ cursor: "pointer" }} title={item.templeLocation} onClick={() => templeDetails(item)}>{item.templeLocation}</div>
//                 </div>
//             )
//         },

//         {
//             name: "Main deity",
//             selector: (item: any) => item.mainDeity,
//             sortable: true,
//             // width: "200px",
//             cell: (item: any) => (
//                 <div >
//                     <div style={{ cursor: "pointer" }} title={item.mainDeity} onClick={() => templeDetails(item)}>{item.mainDeity}</div>
//                 </div>
//             )
//         },
//         {
//             name: "Other deity",
//             selector: (item: any) => item.mainDeity,
//             sortable: true,
//             // width: "200px",
//             cell: (item: any) => (
//                 <div >
//                     <div style={{ cursor: "pointer" }} title={item.otherDeities} onClick={() => templeDetails(item)}>{item.otherDeities ? item.otherDeities : "N/A"}</div>
//                 </div>
//             )
//         },
//         {
//             name: "Offerings",
//             selector: (item: any) => item.poojaOfferings,
//             sortable: true,
//             cell: (item: any) => (
//                 <div >
//                     <div style={{ cursor: "pointer" }} title={item.poojaOfferings} onClick={() => templeDetails(item)} >{item.poojaOfferings}</div>
//                 </div>
//             )
//         },
//         {
//             name: "Antiquity",
//             selector: (item: any) => item.antiquity,
//             sortable: true,
//             // width: "200px",
//             cell: (item: any) => (
//                 <div >
//                     <div style={{ cursor: "pointer" }} title={item.antiquity} onClick={() => templeDetails(item)}>{item.antiquity}</div>
//                 </div>
//             )
//         },

//     ]

//     const customTableStyle1 = {
//         ...customTableStyle,
//         table: {
//             style: {
//                 border: "0.5px solid #E5E3E3"
//             },
//         },
//         headRow: {
//             style: {
//                 borderWidth: "0px",
//                 backgroundColor: "#69B5DE"
//             },
//         },
//         headCells: {
//             style: {
//                 fontWeight: "bold",
//                 fontSize: "15px",
//                 paddingLeft: '16px',
//                 paddingRight: '16px',
//                 border: "none",
//                 justifyContent: "left",
//                 textalign: "left",
//                 backgroundColor: "#69B5DE !important"
//             },
//         },
//         rows: {
//             style: {
//                 borderWidth: "0.5px #E5E3E3",
//                 padding: "0px"
//             }
//         },
//         cells: {
//             style: {
//                 fontSize: "16px",
//                 justifyContent: "left",
//                 paddingLeft: '16px',
//                 paddingRight: '16px',
//                 paddingTop: '0px',
//                 paddingBottom: '0px',
//                 wordBreak: 'break-word',
//                 border: "none",
//             }
//         },
//     }
//     const [pageNumber, setpageNumber]: any = useState(0)
//     const [sizeOfList, setSizeOfList]: any = useState(10)
//     const [viewMode, setViewMode] = useState<'grid' | 'table'>('table');  // Track current view mode


//     const [menuItems, setMenuItems] = useState(
//         Tab_items.map((data: any) => ({ name: data, isOpen: false }))
//     );


//     const paginationComponentOptions = {
//         selectAllRowsItem: true,
//         selectAllRowsItemText: "ALL"
//     };

//     const fetchData = (rowsPerPage: any) => {
//         console.log(`Fetching data for ${rowsPerPage} rows per page`);
//         setSizeOfList(rowsPerPage)
//         // getallgods(rowsPerPage, pageNumber)
//     };


//     /*  ___________________ */


// // SP
//     useEffect(() => {
//         const handler = (e: WheelEvent) => {
//             const dropdownMenus = document.querySelectorAll('.select__menu-list');
//             dropdownMenus.forEach(menu => {
//                 const target = e.target as Node | null;
//                 if (target && menu.contains(target)) {
//                     const { scrollTop, scrollHeight, clientHeight } = menu;
//                     const delta = e.deltaY;
//                     const atTop = scrollTop === 0;
//                     const atBottom = scrollTop + clientHeight >= scrollHeight;
 
//                     if ((atTop && delta < 0) || (atBottom && delta > 0)) {
//                         // Don't block default — manually scroll the page
//                         window.scrollBy({ top: delta, behavior: 'smooth' });
//                     }
//                 }
//             });
//         };
 
//         document.addEventListener('wheel', handler, { passive: false });
//         return () => document.removeEventListener('wheel', handler);
//     }, []);


//     useEffect(() => {
//         const value = `[${districtOption.label},${panchayatoption.label},${additionalOption.label}] `
//         Getdatausingsearch(value)
//         getMessagesByCategory()
//         getAllDistricts()
//         getAllTempleSearchOf()
//     }, [])

//     const getAllTempleSearchOf = () => {
//         UserService.getAllTempleSearchOf(token[0], userID[0]).then((response) => {
//             console.log(response);
//             setShowLoading(true)
//             const options: any = [
//                 { value: "ALL", label: "ALL" },
//                 ...response.data.map((e: any) => ({
//                     value: e.id,
//                     label: e.name
//                 }))]
//             setadditionalOptions(options)
//             setShowLoading(false)
//         })

//             .catch((error) => {
//                 alert(error)
//                 setShowLoading(false);
//             });
//     }



//     useEffect(() => {
//         if (userdata[0] !== null && userdata[0] !== "ROLE_USER" && userdata[0] !== "ROLE_VOLUNTEER" && userdata[0] !== "ROLE_FINANCE" && userdata[0] !== "ROLE_ADMIN" && userdata[0] !== "ROLE_VENDOR") {
//             console.log("user", userdata)
//             history.push("/home")
//         }
//         else if (userdata[0] !== null && uFlag[0] === "false") {
//             history.push("/home")
//         }
//         else if (userdata[0]) {
//             Islogin(true)
//             // getallgods(sizeOfList, pageNumber);

//         }
//         else {
//             Islogin(false)
//             // getallgods(sizeOfList, pageNumber);
//             getMessagesByCategory()
//         }

//     }, [sizeOfList, pageNumber, viewMode])

//     const getMessagesByCategory = () => {
//         UserService.getMessagesByCategory(userId, usertoken, usertoken, "Temple").then((res: any) => {
//             if (res.data !== "" && res.data !== null) {
//                 setCommonModalMesg(res.data)
//                 setCommonmodaltitle("Information")
//                 setCommonmodal(true)
//                 setShowLoading(false)
//             }
//         })
//             .catch((error: any) => {
//                 console.log(error, "error")
//                 setShowLoading(false)
//             })
//     }


//     const getAllState = () => {
//         setShowLoading(true);
//         UserService.getAllstates().then((response) => {
//             console.log(response.data);
//             setStates(response.data)
//             setShowLoading(false);
//         })
//             .catch((error) => {
//                 alert(error)
//                 setShowLoading(false);
//             });
//     }
//     const Details = (item: any) => {
//         if (Capacitor.getPlatform() !== "web" && gods.length === 0) {
//             setHideContent(true)
//         }
//         else {
//             setHideContent(false)
//         }
//         setGods([])
//         setShowgod(false)
//         setDeityId(item.id);
//         setName(item.deityName);
//         setDeityName(item.deityName)
//         setImage(item.image)
//         setDeityImg(item.image)
//         getAllState()
//         setIndex1(2);
//     }
//     // const getallgods = (sizeOfList: any, pageNumber: any) => {
//     //     console.log(islogin)
//     //     setShowLoading(true);
//     //     UserService.getAllTemplesForUsers(token[0], pageNumber, userID[0], sizeOfList).then((response: any) => {
//     //         if (response.data.templeDtos !== undefined || response.data.templeDtos.length !== 0) {
//     //             const data = response.data.templeDtos.map((e: any, i: any) => {
//     //                 return { ...e, serial: i + 1 }
//     //             })
//     //             setTempleList(data);
//     //             setTotalNumersOfList(response.data.totalCount)
//     //         } else {
//     //             setTempleList([]);
//     //             setErrorText("Sorry, No data available")
//     //         }
//     //         setShowLoading(false)
//     //     })
//     //         .catch((error: any) => {
//     //             console.log(error);
//     //             setErrorText("Sorry, No data available")
//     //             setShowLoading(false);
//     //         });
//     // }
//     const views = () => {
//         if (Capacitor.getPlatform() !== "web") {
//             setHideContent(true)
//         }
//         else {
//             setHideContent(false)
//         }
//         setIndex1(0)
//     }
//     const Viewinfo = (item: any) => {
//         setImage(item.image)
//         setName(item.deityName)
//         setDescription(item.deityDescription)
//         // setIsshow(true)
//         setIndex1(1)
//     }
//     const useOutsideAlerter = (refer: any) => {
//         useEffect(() => {
//             function handleClickOutside(event: any) {
//                 if (refer.current && !refer.current.contains(event.target)) {
//                     setIsshow(false)
//                 }
//             }
//             document.addEventListener("mousedown", handleClickOutside);
//             return () => {
//                 document.removeEventListener("mousedown", handleClickOutside);
//             }
//         }, [refer]);
//     }
//     const deitymodal = useRef(null);
//     useOutsideAlerter(deitymodal);
//     const generateRandomColor = () => {
//         const letters = '0123456789ABCDEF';
//         let color = '#';
//         for (let i = 0; i < 6; i++) {
//             color += letters[Math.floor(Math.random() * 16)];
//         }
//         return color;
//     };

//     // MultiColorDot.js


//     const MultiColorDot = (color: any) => {
//         const dotClass = `multi-color-dot`;
//         return <div className={dotClass} style={{ backgroundColor: color }}></div>;
//     };

//     var randomColors: any = useState([]);

//     const stateLiistOptions = states.map((e: any, index: any) => ({
//         value: e,
//         label: e
//     }));
//     const districtLiistOptions = [
//         { value: "ALL", label: "ALL" },
//         ...districts.map((e: any) => ({
//             value: e.districtCode,
//             label: e.districtName
//         }))]
//     const countryLiistOptions = countries.map((e: any, index: any) => ({
//         value: e,
//         label: e
//     }));

//     const [panchayatListOptions, setPanchayatListoptions] = useState([])
//     const [panchayatoption, setPanchayatOption]: any = useState({ value: "ALL", label: "ALL" })

//     const containerStyle = {
//         width: '700px',
//         height: '400px'
//     };
//     var center = {
//         lat: lat,
//         lng: long,
//     };
//     var mapOption = {
//         gestureHandling: "cooperative",
//         minZoom: 4

//     };
//     const targetRef: any = useRef(null);

//     const Submit = () => {
//         const errors: any = {};
//         if (country.length == 0) {
//             errors.country = "Please select the country"
//         }
//         setFormErrors(errors);
//         if (Object.keys(errors).length == 0) {
//             setShowLoading(true)
//             Authservice.SearchTemple(usertoken, country, state, district, town, deityId, temName)
//                 .then((response: any) => {
//                     console.log("Res=>", response)
//                     setGods(response.data)
//                     setShowgod(true);
//                     if (Capacitor.getPlatform() !== "web") {
//                         setHideContent(false);
//                         setTimeout(() => {
//                             if (targetRef.current) {
//                                 targetRef.current.scrollIntoView({ behavior: "smooth" });
//                             }
//                             console.log(showgod, "godddd")
//                         }, 1000)
//                     }
//                     setShowLoading(false)
//                 })
//                 .catch((error) => {
//                     console.log(error);
//                     setShowLoading(false)
//                 });
//         }
//     };
//     const Clear = () => {
//         setState("");
//         setDistrict("");
//         setTown("");
//         setTemName("");
//         setStateOption(null)
//         setDistrictOption(null)
//         setShowgod(false);
//         if (Capacitor.getPlatform() !== "web") {
//             setHideContent(true)
//         }
//     }
//     const [videolinkshow, setVideolinkshow] = useState(false)
//     const [livevideolinkshow, setLivevideolinkshow] = useState(false)
//     const [car, setCar] = useState("")
//     const [bus, setBus] = useState("")
//     const [train, setTrain] = useState("")
//     const [flight, setFlight] = useState("")
//     const [timeOfWorkship, setTimeOfWorkship] = useState("")
//     const [structure, setStructure] = useState("")
//     const [carvings, setCarvings] = useState("")
//     const [dresssCode, setDressCode] = useState("")
//     const [tempcode, setTempCode]: any = useState("")

//     {/* Vinayaki */}
//     const [showMobileFilters, setShowMobileFilters] = useState(false);
//     const [isMobile, setIsMobile] = useState(false);
 
//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };
//         handleResize(); // Run on mount
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);
 
//     const shouldShowFilters = !isMobile || showMobileFilters;

//     const templeDetails = (item: any) => {
//         setTempCode(item.templeCode)
//         setIndex1(3)
//     }

//     const show = (id: any) => {
//         setId(id)
//         Authservice.Templedetails(id)
//             .then((response: any) => {
//                 console.log("Ressss=>", response)
//                 setFacilities(response.data.facilitiesDto)
//                 if (response.data.facilitiesDto.car === "" || response.data.facilitiesDto.car === null) {
//                     setCar("No")
//                 }
//                 else {
//                     setCar(response.data.facilitiesDto.car)
//                 }
//                 if (response.data.facilitiesDto.bus === "" || response.data.facilitiesDto.bus === null) {
//                     setBus("No")
//                 }
//                 else {
//                     setBus(response.data.facilitiesDto.bus)
//                 }
//                 if (response.data.facilitiesDto.train === "" || response.data.facilitiesDto.train === null) {
//                     setTrain("No")
//                 }
//                 else {
//                     setTrain(response.data.facilitiesDto.train)
//                 }
//                 if (response.data.facilitiesDto.flight === "" || response.data.facilitiesDto.flight === null) {
//                     setFlight("No")
//                 }
//                 else {
//                     setFlight(response.data.facilitiesDto.flight)
//                 }
//                 setAerial(response.data.templesDto)
//                 setOfferings(response.data.offeringsAndSignificanceDto);
//                 if (response.data.offeringsAndSignificanceDto.every((e: any) => (e.offeringName == "" && e.significance == ""))) {
//                     setNodata(true)
//                 }
//                 setFestival(response.data.festivalsDto)
//                 if (response.data.festivalsDto.every((e: any) => (e.name == "" && e.description == ""))) {
//                     setNodataFest(true)
//                 }
//                 setpoojaoffer(response.data.poojaOfferingsDto);
//                 setTimings(response.data.templesDto);
//                 if (response.data.templeImgsUrl !== null) {
//                     setGallery(response.data.templeImgsUrl);
//                 } else {
//                     setGallery([]);
//                 }
//                 var long = parseFloat(response.data.templesDto.tempLong)
//                 setLong(long);
//                 var lat = parseFloat(response.data.templesDto.tempLat)
//                 setLat(lat);
//                 var arr: any = [];
//                 console.log(response.data.facilitiesDto.shops)
//                 response.data.facilitiesDto.shops.map((item: any) => {
//                     console.log(item.split('||'))
//                     arr = item.split('||');
//                 });
//                 var array_filter = arr.filter((res: any) => res != "")
//                 setShopIn(array_filter);
//                 // var arr_access: any = [];
//                 // response.data.facilitiesDto.accessibility.map((item: any) => {
//                 //     console.log(item.split('||'))
//                 //     arr_access = item.split('||');
//                 // });
//                 // var mapItem: any = "";
//                 // response.data.templesDto.aerialView.map((item: any) => {
//                 //     console.log(item.split(', '))
//                 //     mapItem = item.split(', ')
//                 // });
//                 // center = {
//                 //     lat: response.data.templesDto.tempLat,
//                 //     lng: response.data.templesDto.tempLong,
//                 // };
//                 // var array_filter_acs = arr_access.filter((res: any) => res != "")
//                 // setAccIn(array_filter_acs);
//                 const times = response.data.templesDto.scheduleAndTimings.split("and")
//                 setTimings(times);
//                 var string = response.data.templesDto.scheduleAndTimings.split('and')
//                 setMorning(string[0].replace('Morning Darshan:', ''))
//                 setEvening(string[1].replace('Evening Darshan:', ''))
//                 setTimerequ(string[2].replace('Time Required:', ''))
//                 setEntry(string[3])
//                 setDressme(string[4].replace('Dress Code:', ''))
//                 setDresswo(string[5].replace('Dress Code:', ''))
//                 setClosetime(string[6]?.replace('Closing Time:', ''))
//                 setVideolink(response.data.templeVideoLinksDto.filter((res: any) => res.type !== 2 && res.type !== null));
//                 setVideoLivelink(response.data.templeVideoLinksDto.filter((res: any) => res.type !== 1 && res.type !== null));
//                 if (response.data.templeVideoLinksDto.filter((res: any) => res.type !== 2 && res.type !== null).every((e: any) => (e.videoLink == "" && e.videoName == ""))) {
//                     setVideolinkshow(true)
//                 }
//                 else {
//                     setVideolinkshow(false)
//                 }
//                 if (response.data.templeVideoLinksDto.filter((res: any) => res.type !== 1 && res.type !== null).every((e: any) => (e.videoLink == "" && e.videoName == ""))) {
//                     setLivevideolinkshow(true)
//                 }
//                 else {
//                     setLivevideolinkshow(false)
//                 }
//             })
//             .catch((error) => {
//                 console.log(error);
//             });
//         console.log("id", id)
//         setShowLoading(false);
//         setIndex1(3);
//     }
//     const back1 = () => {
//         setIndex1(2);
//         setIndex(0);
//         setNodata(false)
//         setNodataFest(false)
//     }
//     const customStyles = {
//         control: (provided: any) => ({
//             ...provided,
//             border: "1px solid black",
//             boxShadow: 'none',
//             fontSize: '15px',
//             // height: '44px',
//             width: '90%',
//             outline: 'none',
//             textAlign: "left"
//         }),
//     };


//     const modalClose = () => {
//         setCommonmodal(false)
//     }


//     const [index, setIndex]: any = useState(0);
//     const getBtnId = (e: any) => {
//         setIndex(e.target.id)
//     };
//     const { handleSubmit } = useForm({
//         mode: "onTouched",
//         reValidateMode: "onChange",
//     });
//     const SearchF = (value: any) => {
//         if (value == "Enter") {
//             Submit()
//         }
//     }
//     const openMap = () => {
//         console.log("lkn")
//         window.open('https://www.google.com/maps/place/' + lat + ',' + long + '/@' + lat + ',' + long + ',')
//     }
//     const getAllDistricts = () => {
//         UserService.getAdmAllDistricts(userID[0], token[0], token[0]).then((response) => {
//             console.log(response);
//             setShowLoading(true)
//             setDistricts(response.data)
//             setShowLoading(false)
//         })

//             .catch((error) => {
//                 alert(error)
//                 setShowLoading(false);
//             });
//     }
//     const handleCountryChange = (e: any) => {
//         console.log(e)
//         if (e) {
//             setCountryOption(e);
//             setCountry(e.value);
//         } else {
//             setCountryOption(null)
//             setCountry("")
//         }
//     }
//     const handleStateChange = (e: any) => {
//         console.log(e)
//         if (e) {
//             setStateOption(e);
//             setState(e.value);
//         } else {
//             setStateOption(null)
//             setState("")
//             setDistricts([])
//             setDistrictOption(null)
//             setDistrict("")
//         }
//     }

//     const getAllPanchayats = (e: any) => {
//         UserService.getAllPanchayats(userID[0], usertoken, usertoken, e).then((response) => {
//             console.log(response.data);
//             const panchayat: any = [
//                 { value: "ALL", label: "ALL" },
//                 ...response.data
//                     .map((e: any) => ({
//                         value: e.panchayatCode,
//                         label: e.panchayatName
//                     }))
//                     .sort((a: any, b: any) => a.label.localeCompare(b.label)) // Sort alphabetically
//             ];
//             setPanchayatListoptions(panchayat);
//             setShowLoading(false);
//         })

//             .catch((error) => {
//                 alert(error)
//                 setShowLoading(false);
//             });
//     }


//     const handleDistrictChange = (e: any) => {
//         console.log(e)
//         if (e) {
//             setDistrictOption(e);
//             setDistrict(e.value);
//             if (e.value !== "ALL") {
//                 getAllPanchayats(e.value)
//                 Getdatausingsearch(`[${e.label},ALL,${additionalOption.label}] ${searchTerm}`)
//             }
//         } else {
//             setDistrictOption({ value: "ALL", label: "ALL" })
//             setDistrict("")
//         }
//         setPanchayatListoptions([])
//         setPanchayatOption({ value: "ALL", label: "ALL" })
//     }

//     const hanldePanchayatChange = (e: any) => {
//         console.log(e)
//         if (e) {
//             setPanchayatOption(e);
//             Getdatausingsearch(`[${districtOption.label},${e.label},${additionalOption.label}] ${searchTerm}`)
//         } else {
//             setPanchayatOption({ value: "ALL", label: "ALL" })
//         }
//     }

//     const hanldeAdditionalChange = (e: any) => {
//         console.log(e)
//         if (e) {
//             setAdditionalOption(e);
//             Getdatausingsearch(`[${districtOption.label},${panchayatoption.label},${e.label}] ${searchTerm}`)
//         } else {
//             setAdditionalOption({ value: "ALL", label: "ALL" })
//         }
//     }


//     const pageNames = ['Temples', 'Temple Details'];

//     // Breadcrumb click handler
//     const handleBreadcrumbClick = (index: any) => {
//         console.log(index, "index")
//         setIndex1(index);
//     };

//     const openContent = (index: number) => {
//         const updatedMenuItems = menuItems.map((item: any, i: number) => ({
//             ...item,
//             isOpen: i === index ? !item.isOpen : false, // Toggle selected item, close others
//         }));
//         setMenuItems(updatedMenuItems);
//     };



//     const setViewModeOfPage = (e: any) => {
//         // getallgods(sizeOfList, pageNumber)
//         setViewMode(e)
//     }

//     const Getdatausingsearch = (value: any) => {
//         UserService.searchdataRecords(token[0], value, userID[0])
//             .then((response: any) => {
//                 console.log(response);
//                 setShowLoading(false);
//                 const data = response.data.map((e: any, i: any) => {
//                     return { ...e, serial: i + 1 }
//                 })
//                 setTempleList(data);
//             })
//             .catch((error: any) => {
//                 console.error("Error fetching data:", error);
//                 setShowLoading(false);
//             });
//     }

//     const handleSearch = (e: any) => {
//         const value = e.detail.value || '';
//         const regex = /[&';=]|--/;
//         if (regex.test(value)) {
//             console.warn('Invalid input detected');
//             if (inputRef.current) {
//                 inputRef.current.value = searchTerm;
//             }
//             return;
//         }
//         setSearchTerm(value);
//         if (value.length > 3 || value.length === 0) {
//             const searchValue = `[${districtOption.label},${panchayatoption.label},${additionalOption.label}] ${value}`;
//             clearTimeout(debounceTimeout);
//             debounceTimeout = setTimeout(() => {
//                 Getdatausingsearch(searchValue);
//             }, 1000);
//         }
//     };


//     const handleFilterChange = (filter: any) => {
//         setSelectedOption(filter);
//     };

//     const goback = () => {
//         setIndex1(0)
//     }



//     return (
//         <IonPage>
//             <HeadFoot User={"login"} Role={'Role'} Name='Home,Temples' />
//             <IonContent>

//                 <IonLoading message="Loading..." spinner={null}
//                     isOpen={showLoading}
//                 />
//                 <Modal show={isShow} className="custom-modal-wrapper">
//                     <Modal.Body className='modal_container'>
//                         <div style={{ textAlign: "center" }}>
//                             <IonText className='area_modal_head'>
//                                 Select Area
//                             </IonText>
//                         </div>
//                         <div style={{ display: "flex", justifyContent: "flex-end" }}>
//                             <IonIcon src={close} className='modal_close_icon close_icon' onClick={() => setIsshow(false)} />
//                         </div>
//                         <div style={{ textAlign: "center" }}>
//                             <IonText className='area_modal_subHead'>
//                                 {name}
//                             </IonText>
//                         </div>
//                         <IonGrid>
//                             <IonRow>
//                                 <IonText className='area_modal_labels'>
//                                     Country
//                                 </IonText>
//                             </IonRow>
//                         </IonGrid>
//                     </Modal.Body>
//                 </Modal>
//                 <div className='page_content_padding horizontal_padding_v2'>
//                     <Breadcrumb pageNames={pageNames}
//                         currentPage={index1}
//                         onBreadcrumbClick={handleBreadcrumbClick} />
//                     {index1 === 0 ? <div className='deity_container'>
//                         <div className="toolbar-container">
//                             <div className="view-toggle">
//                                 <IonIcon
//                                     icon={gridOutline}
//                                     className={`toggle-icon ${viewMode === 'grid' ? 'active' : ''}`}
//                                     onClick={() => setViewModeOfPage('grid')}
//                                 />
//                                 <IonIcon
//                                     icon={listOutline}
//                                     className={`toggle-icon ${viewMode === 'table' ? 'active' : ''}`}
//                                     onClick={() => setViewModeOfPage('table')}
//                                 />
 
                               
//                                 <IonIcon
//                                     className="mobile-toggle-arrow"
//                                     onClick={() => setShowMobileFilters(!showMobileFilters)}
//                                     icon={showMobileFilters ? arrowUpCircle : arrowDownCircle}
//                                     style={{ fontSize: '30px', color: '#576f9f', top: '100px' }}
 
//                                 />
                           
 
//                             </div>
                            
//                             {/* Vinayaki */}
//                             <div className="select-search-container">
//                                 {userId && (
//                                     <>
//                                         {/*changes made for temple arrow by Vinayaki */}
//                                         {/* {isMobile && (
//                                             // <div
//                                             //     className="mobile-toggle-arrow"
//                                             //     onClick={() => setShowMobileFilters(!showMobileFilters)}
//                                             // >
//                                             //     <IonIcon
//                                             //         icon={showMobileFilters ? arrowUpCircle : arrowDownCircle}
//                                             //         style={{ fontSize: '30px', color: '#576f9f' }}
//                                             //     />
 
//                                             // </div>
//                                         )} */}
 
//                                         {shouldShowFilters && (
//                                             <div className="radio-search-container">
//                                                 <div className="select-group">
//                                                     <label className="select-label">District</label>
//                                                     <Select
//                                                         options={districtLiistOptions}
//                                                         value={districtOption}
//                                                         onChange={handleDistrictChange}
//                                                         placeholder="Select District"
//                                                         className="search-box"
                                
//                                                     />
//                                                 </div>
 
//                                                 <div className="select-group">
//                                                     <label className="select-label">Panchayat</label>
//                                                     <Select
//                                                         options={panchayatListOptions}
//                                                         value={panchayatoption}
//                                                         onChange={hanldePanchayatChange}
//                                                         placeholder="Select Panchayat"
//                                                         className="search-box"
//                                                         isDisabled={!districtOption || districtOption.value === "ALL"}
//                                                     />
//                                                 </div>
 
//                                                 <div className="select-group">
//                                                     <label className="select-label">Search on</label>
//                                                     <Select
//                                                         options={additionalOptions}
//                                                         value={additionalOption}
//                                                         placeholder="Select Option"
//                                                         className="search-box"
//                                                         onChange={hanldeAdditionalChange}
//                                                     />
//                                                 </div>
 
//                                                 <IonInput
//                                                     placeholder="Search..."
//                                                     value={searchTerm}
//                                                     clearInput
//                                                     onIonChange={handleSearch}
//                                                     className="search-textbox"
//                                                     ref={inputRef}
//                                                 />
//                                             </div>
//                                         )}
//                                     </>
//                                 )}
//                             </div>
 
//                         </div>
//                         <div className=''>
//                             <IonRow className=' '>
//                                 {/* {TempleList.length > 0 ? <> */}
//                                 {viewMode === 'grid' ? <>   {TempleList.map((item: any, i) => (
//                                     <IonCol sizeLg='6' sizeXl='4' size-md='6' size-xs='12' size-sm='12'>
//                                         <IonCard className='deity_cards'>
//                                             <IonRow>
//                                                 <IonCol size='12'>
//                                                     <IonRow style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                                         <IonCol size='12'>
//                                                             <IonText className='deity_name'>{item.templeName}</IonText>
//                                                             <IonText className='deity_description MainDeity'>
//                                                                 <span>Main Deity</span> : {item.mainDeity}
//                                                             </IonText>
//                                                             <IonText className='deity_description'>
//                                                                 <span> Pooja Offering </span>: {item.poojaOfferings}
//                                                             </IonText>
//                                                         </IonCol>
//                                                     </IonRow>
//                                                     <IonRow style={{ marginTop: "5px" }}>
//                                                         <IonButton onClick={(e) => templeDetails(item)}>
//                                                             <span className='button_padding'>
//                                                                 Select
//                                                                 {/* Area */}
//                                                             </span>
//                                                         </IonButton>
//                                                     </IonRow>
//                                                 </IonCol>
//                                             </IonRow>
//                                         </IonCard>
//                                     </IonCol>
//                                 ))
//                                 }</> : <div style={{ width: "100%" }}>
//                                     <CommonDataTable
//                                         columns={columns}
//                                         data={TempleList}
//                                         loading={showLoading}
//                                         noDataMessage="Sorry, No data available"
//                                         onRowClick={(item: any) => templeDetails(item)}
//                                     />
//                                 </div>}
//                                 {/* </> : <div className='no-materials'>
//                                 <IonText>Sorry, No data available</IonText>
//                             </div>} */}
//                             </IonRow>
//                         </div>
//                     </div> : index1 === 1 ? <IonGrid className='about_deity_container '>
//                         <IonRow style={{ paddingTop: "20px" }}>
//                             <IonCol size='1' className='center_col'>
//                                 <div className='back'>
//                                     <IonIcon onClick={() => {
//                                         setIndex1(0)
//                                     }} src={arrowBack} className="point back" size="large" />
//                                 </div>
//                             </IonCol>
//                             <IonCol size='11'>
//                                 <IonText className='bio_deity'>
//                                     Biography
//                                 </IonText>
//                             </IonCol>
//                         </IonRow>
//                         <IonRow>
//                             <IonCol size-lg="12" size-md="12" size-xs="12">
//                                 <IonImg src={image} className='bio_right_img bio_deity_image' />
//                                 <p className='bio_deity_description'>{description}</p>
//                             </IonCol>
//                         </IonRow>
//                     </IonGrid> :
//                         index1 === 2 ?
//                             <div>
//                                 <IonGrid className=''>
//                                     <IonRow>
//                                         <IonCol className='sa' size='12' sizeLg='5.5'>
//                                             <form onSubmit={handleSubmit(Submit)} onKeyPress={e => SearchF(e.key)}>
//                                                 <IonRow>
//                                                     <IonCol className='center_col' size='1'>
//                                                         <div >
//                                                             <IonIcon onClick={() => views()} className="point back" src={arrowBack} size="large" />
//                                                         </div></IonCol>
//                                                     <IonCol size='10' className='center_col'>
//                                                         <div>
//                                                             <IonText className='select_text'> Select Area</IonText>
//                                                         </div></IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='justify-ion-text-center'>
//                                                     {/* <IonCol size-xs="12" size-sm="6" size-lg="6" size-md="6">
//                                                     <IonLabel className='textsize'> Deity</IonLabel>
//                                                 </IonCol> */}
//                                                     <IonCol className='inputcol' size-xs="12" size-sm="12" size-lg="12" size-md="12">
//                                                         <div className='center_col'>
//                                                             <IonText className='deity_text_search'>{deityName}</IonText>
//                                                         </div>
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='To'>
//                                                     <IonCol size='12'>
//                                                         <IonLabel className='search_label'> Country</IonLabel>
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='Too'>
//                                                     <IonCol size='12'>
//                                                         <Select
//                                                             className={stateMenu ? "custom-select" : "custom-select-dark"}
//                                                             options={countryLiistOptions}
//                                                             value={countryOption}
//                                                             placeholder="Select a country"
//                                                             isClearable
//                                                             styles={customStyles}
//                                                             onChange={handleCountryChange}
//                                                         />
//                                                         {formErrors.country && <span className="alert_input_bottom ">{formErrors.country}</span>}
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='To'>
//                                                     <IonCol size="12" >
//                                                         <IonLabel className='search_label'>State</IonLabel>
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='Too'>
//                                                     <IonCol size='12'>
//                                                         <Select
//                                                             className={stateMenu ? "custom-select" : "custom-select-dark"}
//                                                             options={stateLiistOptions}
//                                                             value={stateOption}
//                                                             placeholder="Select a State"
//                                                             isClearable
//                                                             styles={customStyles}
//                                                             onChange={handleStateChange}
//                                                             menuIsOpen={stateMenu}
//                                                             onMenuClose={() => setStateMenu(false)}
//                                                             onMenuOpen={() => setStateMenu(true)}
//                                                         />
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='To'>
//                                                     <IonCol size='12'>
//                                                         <IonLabel className='search_label'>District</IonLabel>
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='Too'>
//                                                     <IonCol>
//                                                         <Select
//                                                             className={districtMenu ? "custom-select" : "custom-select-dark"}
//                                                             options={districtLiistOptions}
//                                                             value={districtOption}
//                                                             placeholder="Select a District"
//                                                             isClearable
//                                                             styles={customStyles}
//                                                             onChange={handleDistrictChange}
//                                                             menuIsOpen={districtMenu}
//                                                             onMenuClose={() => setDistrictMenu(false)}
//                                                             onMenuOpen={() => setDistrictMenu(true)}
//                                                         />
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='To'>
//                                                     <IonCol>
//                                                         <IonLabel className='search_label'>Village / Town</IonLabel>
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='Too'>
//                                                     <IonCol>
//                                                         <IonInput className='search_text' value={town} onIonChange={(e) => setTown(e.target.value)} />
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow style={{ display: "flex", justifyContent: "center" }}>
//                                                     <div className="center"><p>
//                                                         or</p></div>
//                                                 </IonRow>
//                                                 <IonRow className='To'>
//                                                     <IonCol>
//                                                         <IonLabel className='search_label'>Enter Temple Name </IonLabel>
//                                                     </IonCol>
//                                                 </IonRow>
//                                                 <IonRow className='Too'>
//                                                     <IonCol >
//                                                         <IonInput className='search_text' value={temName} onIonChange={(e) => setTemName(e.target.value)} />
//                                                     </IonCol>
//                                                 </IonRow>

//                                                 <div className='center_col padding_search'>
//                                                     <div >
//                                                         <IonButton className={Capacitor.getPlatform() === "ios" ? 'clear_all border_change_clear' : 'clear_all'} onClick={Clear}>
//                                                             <span className='button_padding'> Clear All</span>

//                                                         </IonButton>
//                                                     </div>
//                                                     <div>
//                                                         <IonButton className='search_btn' type="submit">
//                                                             <span className='button_padding'>Search</span>

//                                                         </IonButton>
//                                                     </div>
//                                                 </div>
//                                             </form>
//                                         </IonCol>
//                                         {hideContent === true ? <></> :
//                                             <IonCol ref={targetRef} className='oo' size='12' sizeLg='6.5'>
//                                                 <IonRow>
//                                                     <div style={{ textAlign: "center", width: "100%", marginTop: "1%" }}>
//                                                         <IonText className='deity_text_search'>Temple Name</IonText>
//                                                     </div>
//                                                 </IonRow>
//                                                 <div className='temple_list_container'>
//                                                     <div className='templenamescroll'>

//                                                         {showgod ?
//                                                             <>
//                                                                 {gods.length == 0 ?
//                                                                     <div className='no_result'>
//                                                                         <IonLabel className='before_search_text'>Not a serviceable area</IonLabel>
//                                                                     </div> : gods.length != 0 ?
//                                                                         <>
//                                                                             <div style={{ color: "red", textAlign: "center", paddingBottom: "10px", fontSize: "14px" }}>
//                                                                                 <span >* Please click on one of the temples displayed in the list to proceed</span>

//                                                                             </div>
//                                                                             {
//                                                                                 gods.map((item: any, i: any) => (
//                                                                                     <div className='temple_list' onClick={() => templeDetails(item.id)}>
//                                                                                         <IonRow >
//                                                                                             <IonCol size='2' >
//                                                                                                 <div className='multi-color-dot'></div>

//                                                                                             </IonCol>
//                                                                                             <IonCol size='10' >
//                                                                                                 <IonLabel
//                                                                                                 >{item.name}
//                                                                                                 </IonLabel>
//                                                                                             </IonCol>


//                                                                                         </IonRow></div>
//                                                                                 ))
//                                                                             }
//                                                                         </> : <></>
//                                                                 }
//                                                             </> :
//                                                             <div className='temple_bg'>
//                                                                 <div className='temple_budha_bg'>
//                                                                 </div>
//                                                                 <div className='search_display'>
//                                                                     <IonLabel className='before_search_text'>Search Your Temple</IonLabel>
//                                                                 </div>
//                                                             </div>
//                                                         }
//                                                     </div>
//                                                 </div>
//                                             </IonCol>}
//                                     </IonRow>
//                                 </IonGrid>
//                             </div> :
//                             index1 === 4 ?
//                                 <div className='temple_container'>
//                                     <div>
//                                         <IonGrid style={{ padding: '0px' }}>
//                                             <IonRow>
//                                                 <IonCol size-lg="3.5" size-md="3.5" size-sm="12" size-xs="12" className='menu_show'>
//                                                     <IonRow>
//                                                         <IonCol size-lg="5" size-xs='4' className='temple_back' >
//                                                             <IonIcon onClick={() => back1()} className='back' src={arrowBack} size="large"></IonIcon>
//                                                         </IonCol>
//                                                     </IonRow>
//                                                     <div className='temple_menu' >

//                                                         <div>
//                                                             <div>
//                                                                 <IonImg className='img_class' src={deityImg + "?v=" + new Date()}>
//                                                                 </IonImg>
//                                                                 <IonLabel className='deity_style'>{deityName}</IonLabel>
//                                                             </div>
//                                                         </div>
//                                                         <div className={index == 0 ? "selected-btn" : "menu-btn"} id="0" onClick={getBtnId}>
//                                                             <IonLabel id="0" onClick={getBtnId} >
//                                                                 About
//                                                             </IonLabel>
//                                                         </div>
//                                                         <div className={index == 1 ? "selected-btn" : "menu-btn"} id="1" onClick={getBtnId}>
//                                                             <IonLabel id="1" onClick={getBtnId} >
//                                                                 Facilities
//                                                             </IonLabel>
//                                                         </div>
//                                                         <div className={index == 2 ? "selected-btn" : "menu-btn"} id="2" onClick={getBtnId}>
//                                                             <IonLabel id="2" onClick={getBtnId}>
//                                                                 Offerings & Significance
//                                                             </IonLabel>
//                                                         </div>
//                                                         <div className={index == 3 ? "selected-btn" : "menu-btn"} id="3" onClick={getBtnId}>
//                                                             <IonLabel id="3" onClick={getBtnId}>
//                                                                 Festivals
//                                                             </IonLabel>
//                                                         </div>
//                                                         <div className={index == 4 ? "selected-btn" : "menu-btn"} id="4" onClick={getBtnId}>
//                                                             <IonLabel id="4" onClick={getBtnId}>
//                                                                 Pooja List
//                                                             </IonLabel>
//                                                         </div>
//                                                         <div className={index == 5 ? "selected-btn" : "menu-btn"} id="5" onClick={getBtnId}>
//                                                             <IonLabel id="5" onClick={getBtnId}>
//                                                                 Aerial View
//                                                             </IonLabel>
//                                                         </div>
//                                                         <div className={index == 6 ? "selected-btn" : "menu-btn"} id="6" onClick={getBtnId}>
//                                                             <IonLabel id="6" onClick={getBtnId}>
//                                                                 Schedule & Timings
//                                                             </IonLabel>
//                                                         </div>
//                                                         <div className={index == 7 ? "selected-btn" : "menu-btn"} id="7" onClick={getBtnId} style={{ borderBottom: "none" }}>
//                                                             <IonLabel id="7" onClick={getBtnId}>
//                                                                 Gallery
//                                                             </IonLabel>
//                                                         </div></div>
//                                                 </IonCol>
//                                                 <IonCol size-lg="8.5" size-md="8.5" size-sm="12" size-xs="12" className="menu-col details-col">
//                                                     <IonRow>
//                                                         <IonCol size-lg="1" size-md="1" size-sm="2" size-xs="2" className="menu_back center_col">
//                                                             <IonIcon onClick={() => back1()} className='back' src={arrowBack} size="large"></IonIcon>
//                                                         </IonCol>

//                                                         <IonCol size-md="12" size-sm="8" size-xs="8" size-lg="12" >
//                                                             <div className="grid"> <IonText className='header_style'>{aerial.name}</IonText></div>

//                                                         </IonCol>
//                                                         <IonCol size-lg="1" size-md="1" size-sm="2" size-xs="2" className="menu_pop center_col">

//                                                             <IonIcon
//                                                                 className="menu_pop"
//                                                                 src={ellipsisVerticalCircleOutline}
//                                                                 size="large"
//                                                                 style={{ cursor: "pointer" }}
//                                                                 id="menu_content"
//                                                                 color="primary"
//                                                             ></IonIcon>
//                                                             <IonPopover
//                                                                 trigger="menu_content"
//                                                                 dismissOnSelect={true}
//                                                                 show-backdrop={false}
//                                                             >
//                                                                 <IonContent style={{ background: "white" }} scrollEvents={true}>
//                                                                     <IonList className='templeTabBtnMainCls'>
//                                                                         <div className={index == 0 ? "selected-btn" : "menu-btn"} id="0" onClick={getBtnId}>
//                                                                             <IonLabel id="0" onClick={getBtnId} >
//                                                                                 About
//                                                                             </IonLabel>
//                                                                         </div>
//                                                                         <div className={index == 1 ? "selected-btn" : "menu-btn"} id="1" onClick={getBtnId}>
//                                                                             <IonLabel id="1" onClick={getBtnId}>
//                                                                                 Facilities
//                                                                             </IonLabel>
//                                                                         </div>
//                                                                         <div className={index == 2 ? "selected-btn" : "menu-btn"} id="2" onClick={getBtnId}>
//                                                                             <IonLabel id="2" onClick={getBtnId}>
//                                                                                 Offerings & Significance
//                                                                             </IonLabel>
//                                                                         </div>
//                                                                         <div className={index == 3 ? "selected-btn" : "menu-btn"} id="3" onClick={getBtnId}>
//                                                                             <IonLabel id="3" onClick={getBtnId}>
//                                                                                 Festivals
//                                                                             </IonLabel>
//                                                                         </div>
//                                                                         <div className={index == 4 ? "selected-btn" : "menu-btn"} id="4" onClick={getBtnId}>
//                                                                             <IonLabel id="4" onClick={getBtnId}>
//                                                                                 Pooja List
//                                                                             </IonLabel>
//                                                                         </div>
//                                                                         <div className={index == 5 ? "selected-btn" : "menu-btn"} id="5" onClick={getBtnId}>
//                                                                             <IonLabel id="5" onClick={getBtnId}>
//                                                                                 Aerial View
//                                                                             </IonLabel>
//                                                                         </div>

//                                                                         <div className={index == 6 ? "selected-btn" : "menu-btn"} id="6" onClick={getBtnId} >
//                                                                             <IonLabel id="6" onClick={getBtnId}>
//                                                                                 Schedule & Timings
//                                                                             </IonLabel>
//                                                                         </div>
//                                                                         <div className={index == 7 ? "selected-btn" : "menu-btn"} id="7" onClick={getBtnId} style={{ borderBottom: "none" }}>
//                                                                             <IonLabel id="7" onClick={getBtnId}>
//                                                                                 Gallery
//                                                                             </IonLabel>
//                                                                         </div>
//                                                                     </IonList>
//                                                                 </IonContent>
//                                                             </IonPopover>

//                                                         </IonCol>


//                                                     </IonRow>
//                                                     {index == 0 ? <div>
//                                                         <div className="grid">
//                                                             <IonGrid>
//                                                                 <IonRow>
//                                                                     <IonCol size-lg="12" size-md="12" size-xs="12">
//                                                                         {gallery.length > 0 ? <div>
//                                                                             <img src={gallery[0]} className='rightImage templeImage' />
//                                                                         </div> : <></>}
//                                                                         <p className='history_style'>{aerial.aboutAndHistory}</p>

//                                                                     </IonCol>
//                                                                     {/* <IonCol size-lg="3" size-md="4" size-xs="5"> */}

//                                                                     {/* </IonCol> */}
//                                                                 </IonRow>
//                                                             </IonGrid>
//                                                         </div>
//                                                     </div> : index == 1 ? <div>
//                                                         <div className='facility_container'>
//                                                             <IonGrid className="grid">
//                                                                 <IonRow>
//                                                                     <IonCol size-lg="12" size-md="12" size-xs="12">
//                                                                         <IonGrid>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Parking Lot
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {facilities.parkingLot === "" ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         : <IonText className='facility_text'>
//                                                                                             {facilities.parkingLot}
//                                                                                         </IonText>}

//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Security
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {facilities.security === "" ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         :
//                                                                                         <IonText className='facility_text'>
//                                                                                             {facilities.security}
//                                                                                         </IonText>}
//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Restrooms
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {facilities.restRooms === "" ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         :
//                                                                                         <IonText className='facility_text'>
//                                                                                             {facilities.restRooms}
//                                                                                         </IonText>}
//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Cloak Counters
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {facilities.cloakCounters === "" ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         :
//                                                                                         <IonText className='facility_text'>
//                                                                                             {facilities.cloakCounters}
//                                                                                         </IonText>}
//                                                                                 </IonCol>
//                                                                             </IonRow>

//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Pooja Provisions
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {facilities.poojaProvisions === "" ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         :
//                                                                                         <IonText className='facility_text'>
//                                                                                             {facilities.poojaProvisions}
//                                                                                         </IonText>}
//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Shop
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {shop.length === 0 ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         :
//                                                                                         <>
//                                                                                             {
//                                                                                                 shop.map((item: any, i: any) => {
//                                                                                                     console.log(item)
//                                                                                                     return (
//                                                                                                         <>

//                                                                                                             <IonText className='facility_text' id={i}>
//                                                                                                                 {item} {i != (shop.length - 1) && <>,</>}
//                                                                                                             </IonText>
//                                                                                                         </>
//                                                                                                     );
//                                                                                                 })
//                                                                                             }
//                                                                                         </>}
//                                                                                 </IonCol>


//                                                                             </IonRow>


//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Cab / Auto Availability
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {facilities.cabAvailablity === "" ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         :
//                                                                                         <IonText className='facility_text'>
//                                                                                             {facilities.cabAvailablity}
//                                                                                         </IonText>}
//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Auditorium
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     {facilities.auditorium === "" ?
//                                                                                         <IonText className='facility_text'>
//                                                                                             N/A
//                                                                                         </IonText>
//                                                                                         :
//                                                                                         <IonText className='facility_text'>
//                                                                                             {facilities.auditorium}
//                                                                                         </IonText>}
//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Car
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     <IonText className='facility_text'>
//                                                                                         {car}
//                                                                                     </IonText>

//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Bus
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     <IonText className='facility_text'>
//                                                                                         {bus}
//                                                                                     </IonText>

//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Train
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     <IonText className='facility_text'>
//                                                                                         {train}
//                                                                                     </IonText>

//                                                                                 </IonCol>
//                                                                             </IonRow>
//                                                                             <IonRow className="remove-border">
//                                                                                 <IonCol size="2" className='tick_container' >
//                                                                                     <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                                     </IonIcon>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="5.5"  >
//                                                                                     <IonText className='facility_text'>
//                                                                                         Flight
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5'>
//                                                                                     <IonText className='facility_text'>
//                                                                                         :
//                                                                                     </IonText>
//                                                                                 </IonCol>
//                                                                                 <IonCol size="4" >
//                                                                                     <IonText className='facility_text'>
//                                                                                         {flight}
//                                                                                     </IonText>

//                                                                                 </IonCol>
//                                                                             </IonRow>



//                                                                         </IonGrid>
//                                                                     </IonCol>
//                                                                 </IonRow>
//                                                             </IonGrid>
//                                                         </div>
//                                                     </div> : index == 2 ? <div>
//                                                         <IonGrid className="grid">
//                                                             {nodata == true ? <div style={{ height: "350px", width: "100%", display: "flex", justifyContent: "center" }}>
//                                                                 <IonText style={{ display: "flex", alignItems: "center", color: "black" }}>No Data Available</IonText>

//                                                             </div> :
//                                                                 <div>
//                                                                     {Offerings.map((item: any) => (
//                                                                         <div>
//                                                                             {(item.offeringName === "" || item.offeringName === null) && (item.significance == "" || item.significance === null) ?
//                                                                                 <div>
//                                                                                 </div> : <div>
//                                                                                     <IonRow>
//                                                                                         <IonText className='offering_head'>{item.offeringName} :</IonText>
//                                                                                     </IonRow>
//                                                                                     <IonRow >
//                                                                                         <p className='offering_style'>&emsp; &emsp; &emsp;{item.significance}</p>
//                                                                                     </IonRow>
//                                                                                 </div>
//                                                                             }
//                                                                         </div>
//                                                                     ))}</div>}
//                                                         </IonGrid>
//                                                     </div> : index == 3 ? <div>
//                                                         <IonGrid className="grid">
//                                                             {nodataFest == true ? <div style={{ height: "350px", width: "100%", display: "flex", justifyContent: "center" }}>
//                                                                 <IonText style={{ display: "flex", alignItems: "center", color: "black" }}>No Data Available</IonText>

//                                                             </div> :
//                                                                 <div>
//                                                                     {festival.map((item: any) => (
//                                                                         <div>
//                                                                             {(item.name == "" || item.name === null) && (item.description == "" || item.description == null) ? <div></div> :
//                                                                                 <div>
//                                                                                     <IonRow>
//                                                                                         <IonText className='offering_head'>{item.name} :</IonText>
//                                                                                     </IonRow>
//                                                                                     <IonRow>
//                                                                                         <p className='offering_style'>&emsp; &emsp; &emsp; {item.description}</p>
//                                                                                     </IonRow>
//                                                                                 </div>}
//                                                                         </div>
//                                                                     ))}</div>}

//                                                         </IonGrid>
//                                                     </div> : index == 4 ? <div>
//                                                         <IonGrid className="grid">
//                                                             <IonRow>
//                                                                 <IonText className='offering_head'>Pooja List</IonText>
//                                                             </IonRow>
//                                                             <IonRow className='pooja_tab'>
//                                                                 <IonCol className="table_column1">
//                                                                     <IonGrid className='table_container'>

//                                                                         <IonRow className="row_head">
//                                                                             <IonCol size='1' className="head-border">
//                                                                                 S.no
//                                                                             </IonCol>
//                                                                             <IonCol size='3.5' className="head-border">
//                                                                                 Name of Vazhipadu
//                                                                             </IonCol>
//                                                                             <IonCol size='4' className="head-border">
//                                                                                 Description
//                                                                             </IonCol>
//                                                                             <IonCol size='1.5' className="head-border">
//                                                                                 Rate
//                                                                             </IonCol>
//                                                                             <IonCol size='2' className="head-border">
//                                                                                 Deity
//                                                                             </IonCol>
//                                                                         </IonRow>
//                                                                         {
//                                                                             poojaoffer.map((item: any, i: any) => (
//                                                                                 <IonRow className="row_col">
//                                                                                     <IonCol size='1' className="row_first col_border">{i + 1}</IonCol>
//                                                                                     <IonCol size='3.5' className="col_border">{item.name}</IonCol>
//                                                                                     <IonCol size='4' className="col_border">{item.description}</IonCol>
//                                                                                     <IonCol size='1.5' className="col_border">&#8377; {item.price}</IonCol>
//                                                                                     <IonCol size='2' className='col_last'>{item.deity.deityName}</IonCol>
//                                                                                 </IonRow>
//                                                                             ))}


//                                                                     </IonGrid>
//                                                                 </IonCol>
//                                                             </IonRow>
//                                                             <div className='menu_back'>
//                                                                 {
//                                                                     poojaoffer.map((item: any, i: any) => (
//                                                                         <IonCard className='pooja_card'>
//                                                                             <IonRow>
//                                                                                 <IonCol className="pooja_col" size='5'>
//                                                                                     {i + 1}. Vazhipadu
//                                                                                 </IonCol>
//                                                                                 <IonCol className="pooja_col" size='0.5' >:</IonCol>
//                                                                                 <IonCol className="pooja_col" size='6.5'>
//                                                                                     {item.name}
//                                                                                 </IonCol>


//                                                                             </IonRow>
//                                                                             <IonRow>
//                                                                                 <IonCol className="pooja_col" size='5'>
//                                                                                     Description
//                                                                                 </IonCol>
//                                                                                 <IonCol className="pooja_col" size='0.5' >:</IonCol>
//                                                                                 <IonCol className="pooja_col" size='6.5'>
//                                                                                     {item.description}
//                                                                                 </IonCol>


//                                                                             </IonRow>
//                                                                             <IonRow>
//                                                                                 <IonCol size='5' className="pooja_col">
//                                                                                     Rate
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5' className="pooja_col">:</IonCol>
//                                                                                 <IonCol size='6.5' className="pooja_col">
//                                                                                     &#8377; {item.price}
//                                                                                 </IonCol>


//                                                                             </IonRow>
//                                                                             <IonRow>
//                                                                                 <IonCol size='5' className="pooja_col">
//                                                                                     Deity
//                                                                                 </IonCol>
//                                                                                 <IonCol size='0.5' className="pooja_col">:</IonCol>
//                                                                                 <IonCol size='6.5' className="pooja_col">
//                                                                                     {item.deity.deityName}
//                                                                                 </IonCol>


//                                                                             </IonRow>
//                                                                         </IonCard>))}
//                                                             </div>

//                                                         </IonGrid>
//                                                     </div> : index == 5 ? <div>
//                                                         <div>
//                                                             <IonGrid className="grid">
//                                                                 <IonRow>
//                                                                     <IonCol size-lg="12" size-md="12" size-xs="12" size-sm="12">

//                                                                         <div className='parent'>
//                                                                             {window.google == undefined ? <LoadScript
//                                                                                 googleMapsApiKey={UserService.mapKey()}
//                                                                             >
//                                                                                 <GoogleMap
//                                                                                     mapContainerClassName="containerStyle"
//                                                                                     center={center}
//                                                                                     zoom={15} options={mapOption}
//                                                                                 >
//                                                                                     <MarkerF position={center} />
//                                                                                 </GoogleMap>
//                                                                             </LoadScript> : <GoogleMap
//                                                                                 mapContainerClassName="containerStyle"
//                                                                                 center={center}
//                                                                                 zoom={15} options={mapOption}
//                                                                             >
//                                                                                 <MarkerF position={center} />
//                                                                             </GoogleMap>}
//                                                                             <div className='child'>
//                                                                                 <IonButton className='map_share' onClick={openMap}>Share
//                                                                                     <IonIcon src={shareSocialSharp} className='share_icon' />
//                                                                                 </IonButton>
//                                                                             </div>

//                                                                         </div>
//                                                                     </IonCol>
//                                                                 </IonRow>
//                                                             </IonGrid>
//                                                         </div>
//                                                     </div> : index == 6 ? <div>
//                                                         <div style={{ padding: "2%" }} className="grid">

//                                                             <IonRow>
//                                                                 <IonText className='offering_head'>Schedule & Timings</IonText>
//                                                             </IonRow>

//                                                             <div className='schedule_container'>
//                                                                 <IonGrid>
//                                                                     <IonRow className="remove-border">
//                                                                         <IonCol size="1" className='tick_container' >
//                                                                             <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                             </IonIcon>
//                                                                         </IonCol>
//                                                                         <IonCol size="4"  >
//                                                                             <IonText className='facility_text'>
//                                                                                 Morning Darsan
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size='0.5'>
//                                                                             <IonText className='facility_text'>
//                                                                                 :
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size="6.5" >
//                                                                             <IonText className='facility_text'>
//                                                                                 {morning}
//                                                                             </IonText>

//                                                                         </IonCol>
//                                                                     </IonRow>
//                                                                     <IonRow className="remove-border">
//                                                                         <IonCol size="1" className='tick_container' >
//                                                                             <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                             </IonIcon>
//                                                                         </IonCol>
//                                                                         <IonCol size="4"  >
//                                                                             <IonText className='facility_text'>
//                                                                                 Evening Darsan
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size='0.5'>
//                                                                             <IonText className='facility_text'>
//                                                                                 :
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size="6.5" >
//                                                                             <IonText className='facility_text'>
//                                                                                 {evening}
//                                                                             </IonText>

//                                                                         </IonCol>
//                                                                     </IonRow>

//                                                                     <IonRow className="remove-border">
//                                                                         <IonCol size="1" className='tick_container' >
//                                                                             <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                             </IonIcon>
//                                                                         </IonCol>
//                                                                         <IonCol size="4"  >
//                                                                             <IonText className='facility_text'>
//                                                                                 Time Required
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size='0.5'>
//                                                                             <IonText className='facility_text'>
//                                                                                 :
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size="6.5" >
//                                                                             <IonText className='facility_text'>
//                                                                                 {timerequ}
//                                                                             </IonText>

//                                                                         </IonCol>
//                                                                     </IonRow>
//                                                                     <IonRow className="remove-border">
//                                                                         <IonCol size="1" className='tick_container' >
//                                                                             <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                             </IonIcon>
//                                                                         </IonCol>
//                                                                         <IonCol size="4"  >
//                                                                             <IonText className='facility_text'>
//                                                                                 Closing Timings
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size='0.5'>
//                                                                             <IonText className='facility_text'>
//                                                                                 :
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size="6.5" >
//                                                                             <IonText className='facility_text'>
//                                                                                 {closetime}
//                                                                             </IonText>

//                                                                         </IonCol>
//                                                                     </IonRow>
//                                                                     <IonRow className="remove-border">
//                                                                         <IonCol size="1" className='tick_container' >
//                                                                             <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                             </IonIcon>
//                                                                         </IonCol>
//                                                                         <IonCol size="4"  >
//                                                                             <IonText className='facility_text'>
//                                                                                 Fees Details
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size='0.5'>
//                                                                             <IonText className='facility_text'>
//                                                                                 :
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size="6.5" >
//                                                                             <IonText className='facility_text'>
//                                                                                 {entry}
//                                                                             </IonText>

//                                                                         </IonCol>
//                                                                     </IonRow>
//                                                                     <IonRow className="remove-border">
//                                                                         <IonCol size="1" className='tick_container' >
//                                                                             <IonIcon className='tick' src={checkmarkCircleSharp} >

//                                                                             </IonIcon>
//                                                                         </IonCol>
//                                                                         <IonCol size="4"  >
//                                                                             <IonText className='facility_text'>
//                                                                                 Dress Code
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size='0.5'>
//                                                                             <IonText className='facility_text'>
//                                                                                 :
//                                                                             </IonText>
//                                                                         </IonCol>
//                                                                         <IonCol size="6.5" >
//                                                                             <IonText className='facility_text'>
//                                                                                 Men - {dressme}
//                                                                             </IonText><br />
//                                                                             <IonText className='facility_text'>
//                                                                                 Women - {dresswo}
//                                                                             </IonText>

//                                                                         </IonCol>
//                                                                     </IonRow>



//                                                                     <IonRow>
//                                                                         <IonCol size-lg="3" size-md="3" size="5">
//                                                                             <IonLabel style={{ fontSize: "14px", fontWeight: "bold" }}></IonLabel>
//                                                                         </IonCol>
//                                                                         <IonCol size-lg="9" size-md="9" size="7">
//                                                                             <IonText></IonText>
//                                                                             <IonText></IonText>
//                                                                         </IonCol>
//                                                                     </IonRow>
//                                                                 </IonGrid>
//                                                             </div>
//                                                         </div>
//                                                     </div> : index == 7 ? <div>
//                                                         <div className="grid">
//                                                             <IonGrid>
//                                                                 <IonRow className="ion-justify-content-center">
//                                                                     {gallery.map((item: any, i: any) => {
//                                                                         return (
//                                                                             <IonCol size-lg="4" size-md="4" size-xs="12">
//                                                                                 <IonCard className='img-card'>
//                                                                                     <IonImg src={item} style={{ cursor: "pointer" }} onClick={() => openModalAndSetIndex(i)} className="img" tabIndex={1}
//                                                                                         onKeyDown={(e) => {
//                                                                                             if (e.key === 'Enter') {
//                                                                                                 openModalAndSetIndex(i)
//                                                                                             }
//                                                                                         }} />
//                                                                                 </IonCard>
//                                                                             </IonCol>
//                                                                         )
//                                                                     })}
//                                                                     {showModal && (
//                                                                         <Lightbox
//                                                                             mainSrc={gallery[indexOfImages]}
//                                                                             nextSrc={gallery.length > 1 ? gallery[(indexOfImages + 1) % gallery.length] : undefined}
//                                                                             prevSrc={
//                                                                                 gallery.length > 1 ? gallery[
//                                                                                     (indexOfImages + gallery.length - 1) % gallery.length
//                                                                                 ] : undefined
//                                                                             }
//                                                                             onCloseRequest={() => setShowModal(false)}
//                                                                             onImageLoad={() => {
//                                                                                 window.dispatchEvent(new Event('resize'));
//                                                                             }}
//                                                                             onMovePrevRequest={() =>
//                                                                                 setIndexOfImages(
//                                                                                     (indexOfImages + gallery.length - 1) % gallery.length
//                                                                                 )
//                                                                             }
//                                                                             onMoveNextRequest={() =>
//                                                                                 setIndexOfImages(
//                                                                                     (indexOfImages + gallery.length + 1) % gallery.length
//                                                                                 )
//                                                                             }
//                                                                         />
//                                                                     )}
//                                                                 </IonRow>

//                                                                 <IonRow style={{ paddingTop: "25px" }}>
//                                                                     <IonText className='offering_head'>Video Link</IonText>
//                                                                 </IonRow>
//                                                                 <div>
//                                                                     {videolinkshow === true ? <div style={{ marginTop: "2%", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                                                         <IonText style={{ color: "black" }}>
//                                                                             No Data Available
//                                                                         </IonText>
//                                                                     </div> : <div>
//                                                                         {videolink.map((item: any) => {
//                                                                             console.log(item)
//                                                                             return (<>
//                                                                                 {item.videoName.length > 0 ? <>
//                                                                                     <div className='video_link'>
//                                                                                         <IonText >{item.videoName}</IonText>
//                                                                                     </div>
//                                                                                     <div className="live_link">

//                                                                                         <a style={{ color: '#13ACFF' }} href={item.videoLink} target='_blank'>{item.videoLink}</a>

//                                                                                     </div>

//                                                                                 </> : <>
//                                                                                 </>}
//                                                                             </>
//                                                                             )
//                                                                         }
//                                                                         )}</div>}
//                                                                 </div>
//                                                                 <div>
//                                                                     <IonRow style={{ paddingTop: "40px" }}>
//                                                                         <IonText className='offering_head'>Live Video Link</IonText>
//                                                                     </IonRow>
//                                                                     {livevideolinkshow === true ? <div style={{ marginTop: "2%", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                                                         <IonText style={{ color: "black" }}>
//                                                                             No Data Available
//                                                                         </IonText></div> : <div>
//                                                                         {videolivelink.map((item: any) => {
//                                                                             console.log(item)
//                                                                             return (<>
//                                                                                 {item.videoName.length > 0 ? <>
//                                                                                     <div className='video_link'>

//                                                                                         <IonText >{item.videoName}</IonText>
//                                                                                     </div>
//                                                                                     <div className='live_link'>
//                                                                                         <a style={{ color: '#13ACFF' }} href={item.videoLink} target='_blank'>{item.videoLink}</a>
//                                                                                     </div>
//                                                                                 </> : <>
//                                                                                 </>}
//                                                                             </>
//                                                                             )
//                                                                         }
//                                                                         )}</div>}
//                                                                 </div>
//                                                             </IonGrid>
//                                                         </div>
//                                                     </div> : <div></div>}
//                                                 </IonCol>
//                                             </IonRow>
//                                             {index == 0 &&
//                                                 <IonRow>
//                                                     <IonCol size-lg="12" size-md="12" size-xs="12" size-sm="12" style={{ padding: "0px" }}>

//                                                         <div className='parent'>
//                                                             {window.google == undefined ? <LoadScript
//                                                                 googleMapsApiKey={UserService.mapKey()}
//                                                             >
//                                                                 <GoogleMap
//                                                                     mapContainerClassName="containerStyle"
//                                                                     center={center}
//                                                                     zoom={15} options={mapOption}
//                                                                 >
//                                                                     <MarkerF position={center} />
//                                                                 </GoogleMap>
//                                                             </LoadScript> : <GoogleMap
//                                                                 mapContainerClassName="containerStyle"
//                                                                 center={center}
//                                                                 zoom={15} options={mapOption}
//                                                             >
//                                                                 <MarkerF position={center} />
//                                                             </GoogleMap>}
//                                                             <div className='child'>
//                                                                 <IonButton className='map_share' onClick={openMap}>Share
//                                                                     <IonIcon src={shareSocialSharp} className='share_icon' />
//                                                                 </IonButton>
//                                                             </div>

//                                                         </div>


//                                                     </IonCol>
//                                                 </IonRow>}
//                                         </IonGrid>
//                                     </div>
//                                 </div> : index1 === 3 ?
//                                     <div className='temple_container'>
//                                         {/* <IonRow className="image-description-container">
//                                             <IonCol size-lg='3' size-md="3" size-xs="12" size-sm="12" className='img_centered'>
//                                                 {(deityImg !== "" && deityImg !== null) && <IonImg src={deityImg + "?v=" + new Date()} className='temple-image' alt="Temple 1" />}
//                                             </IonCol>
//                                             <IonCol size-lg='6' size-md="6" size-xs="12" size-sm="12" className="description-container">
//                                                 <h2 className="temple-name">{temName}</h2>
//                                                 <p className="temple-description">
//                                                 </p>
//                                             </IonCol>
//                                             {gallery.length > 0 ?
//                                                 <IonCol size-lg='3' size-md="3" size-xs="12" size-sm="12" className='img_centered'>
//                                                     <IonImg src={gallery[0]} className='temple-image' />
//                                                 </IonCol> : <></>}
//                                         </IonRow> */}
//                                         <IonGrid className='tab_parent_div'>
//                                             <TempleComponent id={tempcode} isUserSide={true} isedit={true} goBack={goback} />
//                                         </IonGrid>
//                                     </div> :
//                                     <></>}</div >
//                 <CommonModal showModal={Commonmodal} closeModal={modalClose} modaltitle={Commmonmodaltitle} AlertModalMesg={CommonModalMesg} />
//             </IonContent >
//             <Foot />
//         </IonPage >
//     )
// }
// export default Temples;



import {
    IonText, useIonAlert, IonInput, IonRow, IonCol, IonLabel, IonButton,
    IonGrid, IonSelect, IonSelectOption, IonImg, IonIcon, IonPage,
    IonContent, IonItemDivider, IonLoading, IonSlides, IonSlide, IonPopover, IonList, IonCard, IonHeader,
    IonAccordionGroup,
    IonAccordion,
    IonItem,
    IonRadioGroup,
    IonRadio
} from '@ionic/react'
import React, { useEffect, useRef, useState } from "react";
import { informationCircle, arrowBack, key, ellipsisVerticalCircleOutline, close, informationCircleSharp, checkmarkCircleSharp, shareSocialOutline, shareSocialSharp, gridOutline, listOutline } from "ionicons/icons"
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { Modal } from 'react-bootstrap'
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import Authservice from "../Services/auth.service";
import UserHead from "./UserHead";
import Foot from "./Foot";
import "jquery/dist/jquery.min.js"
import { useHistory } from "react-router";
import "./sam-temp.css"
import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';
import { useForm } from "react-hook-form";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Capacitor } from '@capacitor/core';
import CustomSpin from '../components/customSpin';
import Select, { components } from 'react-select';
import UserService from '../Services/user.service';
import { closeicon, infoicon, shareIcon, tick } from '../theme/imagePath';
import HeadFoot from './Head';
import Breadcrumb from '../components/Breadcrumb';
import { searchOutline } from 'ionicons/icons';  // Import the search icon
import DataTable from 'react-data-table-component';
import customTableStyle from '../components/CustomTableStyle';
import CommonDataTable from '../components/datatable';
import TempleAddEdit from './admin/templeAddEdit';
import TempleComponent from './admin/templedetailscomponent';
import CommonModal from '../components/popipInfo';
import { arrowUpCircle, arrowDownCircle } from 'ionicons/icons';







interface Props {
    id1: string;
    deity: string;
    img: string;
}
const Temples: React.FC = () => {

    //changes made for temple collapse by Sakthipriya 
    useEffect(() => {
        const handler = (e: WheelEvent) => {
            const dropdownMenus = document.querySelectorAll('.select__menu-list');

            Array.from(dropdownMenus).forEach(menu => {
                const target = e.target as Node;

                if (menu.contains(target)) {
                    const { scrollTop, scrollHeight, clientHeight } = menu;
                    const delta = e.deltaY;
                    const atTop = scrollTop === 0;
                    const atBottom = scrollTop + clientHeight >= scrollHeight;

                    if ((atTop && delta < 0) || (atBottom && delta > 0)) {
                        e.preventDefault(); // Block default scroll inside menu
                        window.scrollBy({ top: delta, behavior: 'smooth' }); // Scroll the page
                    }
                }
            });
        };

        document.addEventListener('wheel', handler, { passive: false });

        return () => {
            document.removeEventListener('wheel', handler);
        };
    }, []);






    const userdata: any = useState(sessionStorage.getItem("UserData"));
    const uFlag: any = useState(sessionStorage.getItem("uFlag"));
    const [userId]: any = useState(sessionStorage.getItem("UserId"));
    const token: any = useState(sessionStorage.getItem("token"));
    const userID: any = useState(sessionStorage.getItem("UserId"));

    const [errorText, setErrorText] = useState("")
    const [TempleList, setTempleList] = useState([]);
    const [image, setImage] = useState("");
    const [description, setDescription] = useState("");
    const [isShow, setIsshow] = useState(false);
    const [islogin, Islogin] = useState(false)
    // const [index, setIndex]: any = useState(0)
    const [showLoading, setShowLoading] = useState(false);
    // const [id, setId] = useState("");
    const [name, setName] = useState("");
    const [states, setStates]: any = useState([]);
    const history = useHistory()
    // var randomColor = require('randomcolor');
    const [hideContent, setHideContent] = useState(false)
    const [index1, setIndex1] = useState(0);
    const [Alert] = useIonAlert();
    const [usertoken] = useState(sessionStorage.getItem("token"));
    const [state, setState]: any = useState();
    const [country, setCountry] = useState("India");
    const [district, setDistrict]: any = useState()
    const [town, setTown]: any = useState()
    const [temName, setTemName]: any = useState()
    const [deityId, setDeityId] = useState("");
    const [deityName, setDeityName] = useState("");
    const [deityImg, setDeityImg] = useState('');
    const [gods, setGods] = useState([])
    const [id, setId] = useState("");
    const [facilities, setFacilities]: any = useState("");
    const [aerial, setAerial]: any = useState([]);
    const [Offerings, setOfferings]: any = useState([]);
    const [festival, setFestival]: any = useState("");
    const [poojaoffer, setpoojaoffer]: any = useState("");
    const [timings, setTimings]: any = useState([]);
    const [gallery, setGallery]: any = useState([]);
    const [shop, setShopIn]: any = useState([]);
    const [acces, setAccIn]: any = useState([]);
    const [lat, setLat]: any = useState();
    const [long, setLong]: any = useState();
    const [morning, setMorning] = useState("");
    const [evening, setEvening] = useState("");
    const [timerequ, setTimerequ] = useState("");
    const [closetime, setClosetime] = useState("");
    const [entry, setEntry] = useState("");
    const [dressme, setDressme] = useState("");
    const [dresswo, setDresswo] = useState("");
    const [videolink, setVideolink]: any = useState([])
    const [videolivelink, setVideoLivelink]: any = useState([])
    const [nodata, setNodata] = useState(false)
    const [nodataFest, setNodataFest] = useState(false)
    const [indexOfImages, setIndexOfImages]: any = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showgod, setShowgod] = useState(false);
    const openModalAndSetIndex = (index: any) => {
        setIndexOfImages(index);
        setShowModal(true);
    };
    const [stateOption, setStateOption]: any = useState([]);
    const [districtOption, setDistrictOption]: any = useState({ value: "ALL", label: "ALL" });
    const [districts, setDistricts]: any = useState([])
    const [districtMenu, setDistrictMenu]: any = useState(false)
    const [stateMenu, setStateMenu]: any = useState(false)
    const [countries, setCountries] = useState(["India"])
    const [countryOption, setCountryOption]: any = useState({ value: "India", label: "India" });
    const [formErrors, setFormErrors]: any = useState({})
    const [searchTerm, setSearchTerm] = useState('');
    const [totalNumersOfList, setTotalNumersOfList]: any = useState(0)
    const [additionalOption, setAdditionalOption]: any = useState({ value: "ALL", label: "ALL" })
    const [additionalOptions, setadditionalOptions] = useState([])

    let debounceTimeout: any;

    const [Commonmodal, setCommonmodal] = useState(false)
    const [CommonModalMesg, setCommonModalMesg] = useState("")
    const [Commmonmodaltitle, setCommonmodaltitle] = useState("")

    // changes made
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize(); // Run on mount
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const shouldShowFilters = !isMobile || showMobileFilters;






    /*V2 changes*/
    const [selectedOption, setSelectedOption] = useState<string>('all');
    const Tab_items: any = [
        "Summary",
        "About & History",
        "Location",
        "Facilities & Dress Code",
        "Time Of Worship",
        "Pooja Offerings",
        "Festivals",
        "Structures & Carvings",
        "Review",
        "Administration"
    ]

    const filterOptions = [
        { value: 'ALL', label: 'All' },
        { value: 'deity', label: 'Deity Name' },
        { value: 'temple', label: 'Temple Name' },
        { value: 'offering', label: 'Offering Name' },
    ];
    const [searchValue, setsearchValue]: any = useState("")
    const inputRef: any = useRef(null)


    const columns: any = [
        {
            name: "Code",
            selector: (item: any, i: any) => item.templeCode,
            sortable: true,
            width: "130px",
            cell: (item: any) => (
                <div >
                    <div style={{ cursor: "pointer" }} onClick={() => templeDetails(item)}>{item.templeCode}</div>
                </div>
            )
        },
        // changes made
        {
            name: "Name",
            selector: (item: any) => item.templeName,
            sortable: true,
            width: "300px",
            cell: (item: any) => (
                <div >
                    <div style={{ cursor: "pointer" }} title={item.templeName} onClick={() => templeDetails(item)} >{item.templeName}</div>
                </div>
            )
        },
        {
            name: "Location",
            selector: (item: any) => item.templeLocation,
            sortable: true,
            width: "500px",
            cell: (item: any) => (
                <div >
                    <div style={{ cursor: "pointer", overflow: "hidden" }} title={item.templeLocation} onClick={() => templeDetails(item)}>{item.templeLocation}</div>
                </div>
            )
        },

        {
            name: "Main deity",
            selector: (item: any) => item.mainDeity,
            sortable: true,
            width: "200px",
            cell: (item: any) => (
                <div >
                    <div style={{ cursor: "pointer" }} title={item.mainDeity} onClick={() => templeDetails(item)}>{item.mainDeity}</div>
                </div>
            )
        },
        {
            name: "Other deity",
            selector: (item: any) => item.mainDeity,
            sortable: true,
            width: "200px",
            cell: (item: any) => (
                <div >
                    <div style={{ cursor: "pointer", overflow: "hidden" }} title={item.otherDeities} onClick={() => templeDetails(item)}>{item.otherDeities ? item.otherDeities : "N/A"}</div>
                </div>
            )
        },
        {
            name: "Offerings",
            selector: (item: any) => item.poojaOfferings,
            sortable: true,
            width: "300px",
            cell: (item: any) => (
                <div >
                    <div style={{ cursor: "pointer", overflow: "hidden" }} title={item.poojaOfferings} onClick={() => templeDetails(item)} >{item.poojaOfferings}</div>
                </div>
            )
        },
        {
            name: "Antiquity",
            selector: (item: any) => item.antiquity,
            sortable: true,
            width: "200px",
            cell: (item: any) => (
                <div >
                    <div style={{ cursor: "pointer" }} title={item.antiquity} onClick={() => templeDetails(item)}>{item.antiquity}</div>
                </div>
            )
        },

    ]

    const customTableStyle1 = {
        ...customTableStyle,
        table: {
            style: {
                border: "0.5px solid #E5E3E3"
            },
        },
        headRow: {
            style: {
                borderWidth: "0px",
                backgroundColor: "#69B5DE"
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                paddingLeft: '16px',
                paddingRight: '16px',
                border: "none",
                justifyContent: "left",
                textalign: "left",
                backgroundColor: "#69B5DE !important"
            },
        },
        rows: {
            style: {
                borderWidth: "0.5px #E5E3E3",
                padding: "0px"
            }
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "left",
                paddingLeft: '16px',
                paddingRight: '16px',
                paddingTop: '0px',
                paddingBottom: '0px',
                wordBreak: 'break-word',
                border: "none",
            }
        },
    }
    const [pageNumber, setpageNumber]: any = useState(0)
    const [sizeOfList, setSizeOfList]: any = useState(10)
    const [viewMode, setViewMode] = useState<'grid' | 'table'>('table');  // Track current view mode


    const [menuItems, setMenuItems] = useState(
        Tab_items.map((data: any) => ({ name: data, isOpen: false }))
    );


    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };

    const fetchData = (rowsPerPage: any) => {
        console.log(`Fetching data for ${rowsPerPage} rows per page`);
        setSizeOfList(rowsPerPage)
        // getallgods(rowsPerPage, pageNumber)
    };


    /*  ___________________ */




    useEffect(() => {
        const value = `[${districtOption.label},${panchayatoption.label},${additionalOption.label}] `
        Getdatausingsearch(value)
        getMessagesByCategory()
        getAllDistricts()
        getAllTempleSearchOf()
    }, [])

    const getAllTempleSearchOf = () => {
        UserService.getAllTempleSearchOf(token[0], userID[0]).then((response) => {
            console.log(response);
            setShowLoading(true)
            const options: any = [
                { value: "ALL", label: "ALL" },
                ...response.data.map((e: any) => ({
                    value: e.id,
                    label: e.name
                }))]
            setadditionalOptions(options)
            setShowLoading(false)
        })

            .catch((error) => {
                alert(error)
                setShowLoading(false);
            });
    }



    useEffect(() => {
        if (userdata[0] !== null && userdata[0] !== "ROLE_USER" && userdata[0] !== "ROLE_VOLUNTEER" && userdata[0] !== "ROLE_FINANCE" && userdata[0] !== "ROLE_ADMIN" && userdata[0] !== "ROLE_VENDOR") {
            console.log("user", userdata)
            history.push("/home")
        }
        else if (userdata[0] !== null && uFlag[0] === "false") {
            history.push("/home")
        }
        else if (userdata[0]) {
            Islogin(true)
            // getallgods(sizeOfList, pageNumber);

        }
        else {
            Islogin(false)
            // getallgods(sizeOfList, pageNumber);
            getMessagesByCategory()
        }

    }, [sizeOfList, pageNumber, viewMode])

    const getMessagesByCategory = () => {
        UserService.getMessagesByCategory(userId, usertoken, usertoken, "Temple").then((res: any) => {
            if (res.data !== "" && res.data !== null) {
                setCommonModalMesg(res.data)
                setCommonmodaltitle("Information")
                setCommonmodal(true)
                setShowLoading(false)
            }
        })
            .catch((error: any) => {
                console.log(error, "error")
                setShowLoading(false)
            })
    }





    const getAllState = () => {
        setShowLoading(true);
        UserService.getAllstates().then((response) => {
            console.log(response.data);
            setStates(response.data)
            setShowLoading(false);
        })
            .catch((error) => {
                alert(error)
                setShowLoading(false);
            });
    }
    const Details = (item: any) => {
        if (Capacitor.getPlatform() !== "web" && gods.length === 0) {
            setHideContent(true)
        }
        else {
            setHideContent(false)
        }
        setGods([])
        setShowgod(false)
        setDeityId(item.id);
        setName(item.deityName);
        setDeityName(item.deityName)
        setImage(item.image)
        setDeityImg(item.image)
        getAllState()
        setIndex1(2);
    }
    // const getallgods = (sizeOfList: any, pageNumber: any) => {
    //     console.log(islogin)
    //     setShowLoading(true);
    //     UserService.getAllTemplesForUsers(token[0], pageNumber, userID[0], sizeOfList).then((response: any) => {
    //         if (response.data.templeDtos !== undefined || response.data.templeDtos.length !== 0) {
    //             const data = response.data.templeDtos.map((e: any, i: any) => {
    //                 return { ...e, serial: i + 1 }
    //             })
    //             setTempleList(data);
    //             setTotalNumersOfList(response.data.totalCount)
    //         } else {
    //             setTempleList([]);
    //             setErrorText("Sorry, No data available")
    //         }
    //         setShowLoading(false)
    //     })
    //         .catch((error: any) => {
    //             console.log(error);
    //             setErrorText("Sorry, No data available")
    //             setShowLoading(false);
    //         });
    // }
    const views = () => {
        if (Capacitor.getPlatform() !== "web") {
            setHideContent(true)
        }
        else {
            setHideContent(false)
        }
        setIndex1(0)
    }
    const Viewinfo = (item: any) => {
        setImage(item.image)
        setName(item.deityName)
        setDescription(item.deityDescription)
        // setIsshow(true)
        setIndex1(1)
    }
    const useOutsideAlerter = (refer: any) => {
        useEffect(() => {
            function handleClickOutside(event: any) {
                if (refer.current && !refer.current.contains(event.target)) {
                    setIsshow(false)
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            }
        }, [refer]);
    }
    const deitymodal = useRef(null);
    useOutsideAlerter(deitymodal);
    const generateRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    // MultiColorDot.js


    const MultiColorDot = (color: any) => {
        const dotClass = `multi-color-dot`;
        return <div className={dotClass} style={{ backgroundColor: color }}></div>;
    };

    var randomColors: any = useState([]);

    const stateLiistOptions = states.map((e: any, index: any) => ({
        value: e,
        label: e
    }));
    const districtLiistOptions = [
        { value: "ALL", label: "ALL" },
        ...districts.map((e: any) => ({
            value: e.districtCode,
            label: e.districtName
        }))]
    const countryLiistOptions = countries.map((e: any, index: any) => ({
        value: e,
        label: e
    }));

    const [panchayatListOptions, setPanchayatListoptions] = useState([])
    const [panchayatoption, setPanchayatOption]: any = useState({ value: "ALL", label: "ALL" })

    const containerStyle = {
        width: '700px',
        height: '400px'
    };
    var center = {
        lat: lat,
        lng: long,
    };
    var mapOption = {
        gestureHandling: "cooperative",
        minZoom: 4

    };
    const targetRef: any = useRef(null);

    const Submit = () => {
        const errors: any = {};
        if (country.length == 0) {
            errors.country = "Please select the country"
        }
        setFormErrors(errors);
        if (Object.keys(errors).length == 0) {
            setShowLoading(true)
            Authservice.SearchTemple(usertoken, country, state, district, town, deityId, temName)
                .then((response: any) => {
                    console.log("Res=>", response)
                    setGods(response.data)
                    setShowgod(true);
                    if (Capacitor.getPlatform() !== "web") {
                        setHideContent(false);
                        setTimeout(() => {
                            if (targetRef.current) {
                                targetRef.current.scrollIntoView({ behavior: "smooth" });
                            }
                            console.log(showgod, "godddd")
                        }, 1000)
                    }
                    setShowLoading(false)
                })
                .catch((error) => {
                    console.log(error);
                    setShowLoading(false)
                });
        }
    };
    const Clear = () => {
        setState("");
        setDistrict("");
        setTown("");
        setTemName("");
        setStateOption(null)
        setDistrictOption(null)
        setShowgod(false);
        if (Capacitor.getPlatform() !== "web") {
            setHideContent(true)
        }
    }
    const [videolinkshow, setVideolinkshow] = useState(false)
    const [livevideolinkshow, setLivevideolinkshow] = useState(false)
    const [car, setCar] = useState("")
    const [bus, setBus] = useState("")
    const [train, setTrain] = useState("")
    const [flight, setFlight] = useState("")
    const [timeOfWorkship, setTimeOfWorkship] = useState("")
    const [structure, setStructure] = useState("")
    const [carvings, setCarvings] = useState("")
    const [dresssCode, setDressCode] = useState("")
    const [tempcode, setTempCode]: any = useState("")


    const templeDetails = (item: any) => {
        setTempCode(item.templeCode)
        setIndex1(3)
    }

    const show = (id: any) => {
        setId(id)
        Authservice.Templedetails(id)
            .then((response: any) => {
                console.log("Ressss=>", response)
                setFacilities(response.data.facilitiesDto)
                if (response.data.facilitiesDto.car === "" || response.data.facilitiesDto.car === null) {
                    setCar("No")
                }
                else {
                    setCar(response.data.facilitiesDto.car)
                }
                if (response.data.facilitiesDto.bus === "" || response.data.facilitiesDto.bus === null) {
                    setBus("No")
                }
                else {
                    setBus(response.data.facilitiesDto.bus)
                }
                if (response.data.facilitiesDto.train === "" || response.data.facilitiesDto.train === null) {
                    setTrain("No")
                }
                else {
                    setTrain(response.data.facilitiesDto.train)
                }
                if (response.data.facilitiesDto.flight === "" || response.data.facilitiesDto.flight === null) {
                    setFlight("No")
                }
                else {
                    setFlight(response.data.facilitiesDto.flight)
                }
                setAerial(response.data.templesDto)
                setOfferings(response.data.offeringsAndSignificanceDto);
                if (response.data.offeringsAndSignificanceDto.every((e: any) => (e.offeringName == "" && e.significance == ""))) {
                    setNodata(true)
                }
                setFestival(response.data.festivalsDto)
                if (response.data.festivalsDto.every((e: any) => (e.name == "" && e.description == ""))) {
                    setNodataFest(true)
                }
                setpoojaoffer(response.data.poojaOfferingsDto);
                setTimings(response.data.templesDto);
                if (response.data.templeImgsUrl !== null) {
                    setGallery(response.data.templeImgsUrl);
                } else {
                    setGallery([]);
                }
                var long = parseFloat(response.data.templesDto.tempLong)
                setLong(long);
                var lat = parseFloat(response.data.templesDto.tempLat)
                setLat(lat);
                var arr: any = [];
                console.log(response.data.facilitiesDto.shops)
                response.data.facilitiesDto.shops.map((item: any) => {
                    console.log(item.split('||'))
                    arr = item.split('||');
                });
                var array_filter = arr.filter((res: any) => res != "")
                setShopIn(array_filter);
                // var arr_access: any = [];
                // response.data.facilitiesDto.accessibility.map((item: any) => {
                //     console.log(item.split('||'))
                //     arr_access = item.split('||');
                // });
                // var mapItem: any = "";
                // response.data.templesDto.aerialView.map((item: any) => {
                //     console.log(item.split(', '))
                //     mapItem = item.split(', ')
                // });
                // center = {
                //     lat: response.data.templesDto.tempLat,
                //     lng: response.data.templesDto.tempLong,
                // };
                // var array_filter_acs = arr_access.filter((res: any) => res != "")
                // setAccIn(array_filter_acs);
                const times = response.data.templesDto.scheduleAndTimings.split("and")
                setTimings(times);
                var string = response.data.templesDto.scheduleAndTimings.split('and')
                setMorning(string[0].replace('Morning Darshan:', ''))
                setEvening(string[1].replace('Evening Darshan:', ''))
                setTimerequ(string[2].replace('Time Required:', ''))
                setEntry(string[3])
                setDressme(string[4].replace('Dress Code:', ''))
                setDresswo(string[5].replace('Dress Code:', ''))
                setClosetime(string[6]?.replace('Closing Time:', ''))
                setVideolink(response.data.templeVideoLinksDto.filter((res: any) => res.type !== 2 && res.type !== null));
                setVideoLivelink(response.data.templeVideoLinksDto.filter((res: any) => res.type !== 1 && res.type !== null));
                if (response.data.templeVideoLinksDto.filter((res: any) => res.type !== 2 && res.type !== null).every((e: any) => (e.videoLink == "" && e.videoName == ""))) {
                    setVideolinkshow(true)
                }
                else {
                    setVideolinkshow(false)
                }
                if (response.data.templeVideoLinksDto.filter((res: any) => res.type !== 1 && res.type !== null).every((e: any) => (e.videoLink == "" && e.videoName == ""))) {
                    setLivevideolinkshow(true)
                }
                else {
                    setLivevideolinkshow(false)
                }
            })
            .catch((error) => {
                console.log(error);
            });
        console.log("id", id)
        setShowLoading(false);
        setIndex1(3);
    }
    const back1 = () => {
        setIndex1(2);
        setIndex(0);
        setNodata(false)
        setNodataFest(false)
    }
    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            border: "1px solid black",
            boxShadow: 'none',
            fontSize: '15px',
            // height: '44px',
            width: '90%',
            outline: 'none',
            textAlign: "left"
        }),
    };


    const modalClose = () => {
        setCommonmodal(false)
    }


    const [index, setIndex]: any = useState(0);
    const getBtnId = (e: any) => {
        setIndex(e.target.id)
    };
    const { handleSubmit } = useForm({
        mode: "onTouched",
        reValidateMode: "onChange",
    });
    const SearchF = (value: any) => {
        if (value == "Enter") {
            Submit()
        }
    }
    const openMap = () => {
        console.log("lkn")
        window.open('https://www.google.com/maps/place/' + lat + ',' + long + '/@' + lat + ',' + long + ',')
    }
    const getAllDistricts = () => {
        UserService.getAdmAllDistricts(userID[0], token[0], token[0]).then((response) => {
            console.log(response);
            setShowLoading(true)
            setDistricts(response.data)
            setShowLoading(false)
        })

            .catch((error) => {
                alert(error)
                setShowLoading(false);
            });
    }
    const handleCountryChange = (e: any) => {
        console.log(e)
        if (e) {
            setCountryOption(e);
            setCountry(e.value);
        } else {
            setCountryOption(null)
            setCountry("")
        }
    }
    const handleStateChange = (e: any) => {
        console.log(e)
        if (e) {
            setStateOption(e);
            setState(e.value);
        } else {
            setStateOption(null)
            setState("")
            setDistricts([])
            setDistrictOption(null)
            setDistrict("")
        }
    }

    const getAllPanchayats = (e: any) => {
        UserService.getAllPanchayats(userID[0], usertoken, usertoken, e).then((response) => {
            console.log(response.data);
            const panchayat: any = [
                { value: "ALL", label: "ALL" },
                ...response.data
                    .map((e: any) => ({
                        value: e.panchayatCode,
                        label: e.panchayatName
                    }))
                    .sort((a: any, b: any) => a.label.localeCompare(b.label)) // Sort alphabetically
            ];
            setPanchayatListoptions(panchayat);
            setShowLoading(false);
        })

            .catch((error) => {
                alert(error)
                setShowLoading(false);
            });
    }


    const handleDistrictChange = (e: any) => {
        console.log(e)
        if (e) {
            setDistrictOption(e);
            setDistrict(e.value);
            if (e.value !== "ALL") {
                getAllPanchayats(e.value)
                Getdatausingsearch(`[${e.label},ALL,${additionalOption.label}] ${searchTerm}`)
            }
        } else {
            setDistrictOption({ value: "ALL", label: "ALL" })
            setDistrict("")
        }
        setPanchayatListoptions([])
        setPanchayatOption({ value: "ALL", label: "ALL" })
    }

    const hanldePanchayatChange = (e: any) => {
        console.log(e)
        if (e) {
            setPanchayatOption(e);
            Getdatausingsearch(`[${districtOption.label},${e.label},${additionalOption.label}] ${searchTerm}`)
        } else {
            setPanchayatOption({ value: "ALL", label: "ALL" })
        }
    }

    const hanldeAdditionalChange = (e: any) => {
        console.log(e)
        if (e) {
            setAdditionalOption(e);
            Getdatausingsearch(`[${districtOption.label},${panchayatoption.label},${e.label}] ${searchTerm}`)
        } else {
            setAdditionalOption({ value: "ALL", label: "ALL" })
        }
    }


    const pageNames = ['Temples', 'Temple Details'];

    // Breadcrumb click handler
    const handleBreadcrumbClick = (index: any) => {
        console.log(index, "index")
        setIndex1(index);
    };

    const openContent = (index: number) => {
        const updatedMenuItems = menuItems.map((item: any, i: number) => ({
            ...item,
            isOpen: i === index ? !item.isOpen : false, // Toggle selected item, close others
        }));
        setMenuItems(updatedMenuItems);
    };



    const setViewModeOfPage = (e: any) => {
        // getallgods(sizeOfList, pageNumber)
        setViewMode(e)
    }

    const Getdatausingsearch = (value: any) => {
        UserService.searchdataRecords(token[0], value, userID[0])
            .then((response: any) => {
                console.log(response);
                setShowLoading(false);
                const data = response.data.map((e: any, i: any) => {
                    return { ...e, serial: i + 1 }
                })
                setTempleList(data);
            })
            .catch((error: any) => {
                console.error("Error fetching data:", error);
                setShowLoading(false);
            });
    }

    const handleSearch = (e: any) => {
        const value = e.detail.value || '';
        const regex = /[&';=]|--/;
        if (regex.test(value)) {
            console.warn('Invalid input detected');
            if (inputRef.current) {
                inputRef.current.value = searchTerm;
            }
            return;
        }
        setSearchTerm(value);
        if (value.length > 3 || value.length === 0) {
            const searchValue = `[${districtOption.label},${panchayatoption.label},${additionalOption.label}] ${value}`;
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                Getdatausingsearch(searchValue);
            }, 1000);
        }
    };


    const handleFilterChange = (filter: any) => {
        setSelectedOption(filter);
    };

    const goback = () => {
        setIndex1(0)
    }



    return (
        <IonPage>
            <HeadFoot User={"login"} Role={'Role'} Name='Home,Temples' />
            <IonContent>

                <IonLoading message="Loading..." spinner={null}
                    isOpen={showLoading}
                />
                <Modal show={isShow} className="custom-modal-wrapper">
                    <Modal.Body className='modal_container'>
                        <div style={{ textAlign: "center" }}>
                            <IonText className='area_modal_head'>
                                Select Area
                            </IonText>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <IonIcon src={close} className='modal_close_icon close_icon' onClick={() => setIsshow(false)} />
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <IonText className='area_modal_subHead'>
                                {name}
                            </IonText>
                        </div>
                        <IonGrid>
                            <IonRow>
                                <IonText className='area_modal_labels'>
                                    Country
                                </IonText>
                            </IonRow>
                        </IonGrid>
                    </Modal.Body>
                </Modal>
                <div className='page_content_padding horizontal_padding_v2'>
                    <Breadcrumb pageNames={pageNames}
                        currentPage={index1}
                        onBreadcrumbClick={handleBreadcrumbClick} />
                    {index1 === 0 ? <div className='deity_container'>
                        {/* toolbar-container */}
                        <div style={{
                            display: 'flex',
                            flexDirection: window.innerWidth < 768 ? 'column' : 'row', // Stack vertically on mobile, horizontally on desktop
                            gap: window.innerWidth < 768 ? '15px' : '20px', // Smaller gap on mobile, larger on desktop
                            padding: window.innerWidth < 768 ? '10px' : '15px 20px', // Less padding on mobile, more on desktop
                            alignItems: window.innerWidth < 768 ? 'center' : 'center', // Center items horizontally on mobile, vertically on desktop
                            width: '100%',
                            boxSizing: 'border-box'
                        }}>
                            <div style={{
                                display: 'flex',
                                gap: '15px',
                                alignItems: 'center',
                                width: window.innerWidth < 768 ? '100%' : 'auto', // Full width on mobile, natural width on desktop
                                justifyContent: window.innerWidth < 768 ? 'center' : 'flex-start' // Center icons on mobile, left-align on desktop
                            }}>
                                <IonIcon
                                    icon={gridOutline}
                                    // Inline conditional styling for active state
                                    style={{

                                        fontSize: '24px',
                                        color: '#576f9f',
                                        cursor: 'pointer',
                                        border: '1px solid #576f9f',
                                        borderRadius: '5px',
                                        padding: '5px 10px',
                                        marginTop: '20px'
                                    }}
                                    onClick={() => setViewModeOfPage('grid')}
                                />
                                <IonIcon
                                    icon={listOutline}
                                    // Inline conditional styling for active state
                                    style={{
                                        fontSize: '24px',
                                        color: '#576f9f',
                                        cursor: 'pointer',
                                        border: '1px solid #576f9f',
                                        borderRadius: '5px',
                                        padding: '5px 10px',
                                        marginTop: '20px'
                                    }}
                                    onClick={() => setViewModeOfPage('table')}
                                />

                                {/* Arrow to toggle filters for mobile view only */}
                                {window.innerWidth < 768 && ( // Only show on mobile
                                    <IonIcon
                                        onClick={() => setShowMobileFilters(!showMobileFilters)}
                                        icon={showMobileFilters ? arrowUpCircle : arrowDownCircle}
                                        style={{
                                            fontSize: '24px', color: '#576f9f', cursor: 'pointer', border: '1px solid #576f9f',
                                            borderRadius: '5px', padding: '5px 10px', marginTop: '20px'
                                        }}
                                    />
                                )}
                            </div>

                            <div style={{
                                width: window.innerWidth < 768 ? '100%' : 'auto', // Full width on mobile, natural on desktop
                                display: 'flex',
                                flexDirection: window.innerWidth < 768 ? 'column' : 'row', // Stack vertically on mobile, horizontally on desktop
                                gap: window.innerWidth < 768 ? '15px' : '20px', // Smaller gap on mobile, larger on desktop
                                alignItems: window.innerWidth < 768 ? 'center' : 'center', // Center search/filters on mobile, center vertically on desktop
                                justifyContent: window.innerWidth < 768 ? 'center' : 'flex-end', // Center on mobile, right-align on desktop
                                flexGrow: window.innerWidth < 768 ? '0' : '1', // Allow to grow on desktop
                                flexWrap: 'wrap', // Allow items to wrap on multiple lines if space is tight


                            }}>
                                {userId && (
                                    <>
                                        {/* Search is always visible */}
                                        <IonInput
                                            placeholder="Search..."
                                            value={searchTerm}
                                            clearInput
                                            onIonChange={handleSearch}
                                            ref={inputRef}
                                            style={{
                                                width: window.innerWidth < 768 ? '90%' : 'auto', // Responsive width
                                                minWidth: window.innerWidth < 768 ? 'auto' : '200px', // Min width for desktop
                                                maxWidth: window.innerWidth < 768 ? '400px' : '300px', // Max width for input
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                marginTop: '20px',
                                                borderRadius: '5px',

                                                flexShrink: '0' // Prevent input from shrinking too much

                                            }}
                                        />

                                        {/* Filters only visible when toggle is open or on desktop */}
                                        {shouldShowFilters && (
                                            <div style={{
                                                width: window.innerWidth < 768 ? '90%' : 'auto', // Responsive width
                                                maxWidth: window.innerWidth < 768 ? '400px' : 'none', // Max width for filters on mobile
                                                display: 'flex',
                                                flexDirection: window.innerWidth < 768 ? 'column' : 'row', // Stack vertically on mobile, horizontally on desktop
                                                gap: window.innerWidth < 768 ? '15px' : '20px', // Responsive gap
                                                alignItems: 'stretch', // Stretch items to fill width on mobile
                                                justifyContent: window.innerWidth < 768 ? 'flex-start' : 'flex-end', // Align on mobile, right-align on desktop
                                                flexWrap: 'wrap' // Allow dropdowns to wrap
                                            }}>
                                                <div style={{
                                                    width: window.innerWidth < 768 ? '100%' : 'auto', // Full width on mobile, natural on desktop
                                                    minWidth: window.innerWidth < 768 ? 'auto' : '150px', // Min width for desktop dropdown
                                                    flexGrow: window.innerWidth < 768 ? '0' : '1', // Allow to grow on desktop
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '10px'
                                                }}>
                                                    <label style={{ fontWeight: '500', color: '#333', fontSize: '0.9em' }}>District</label>
                                                    <Select
                                                        options={districtLiistOptions}
                                                        value={districtOption}
                                                        onChange={handleDistrictChange}
                                                        placeholder="Select District"
                                                        className="search-box" // Keeping for react-select's internal structure
                                                        classNamePrefix="search-box"
                                                        styles={{ container: (base) => ({ ...base, width: '100%' }) }} // Ensure select fills its container
                                                    />
                                                </div>

                                                <div style={{
                                                    width: window.innerWidth < 768 ? '100%' : 'auto', // Full width on mobile, natural on desktop
                                                    minWidth: window.innerWidth < 768 ? 'auto' : '150px', // Min width for desktop dropdown
                                                    flexGrow: window.innerWidth < 768 ? '0' : '1', // Allow to grow on desktop
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '10px'
                                                }}>
                                                    <label style={{ fontWeight: '500', color: '#333', fontSize: '0.9em' }}>Panchayat</label>
                                                    <Select
                                                        options={panchayatListOptions}
                                                        value={panchayatoption}
                                                        onChange={hanldePanchayatChange}
                                                        placeholder="Select Panchayat"
                                                        className="search-box"
                                                        classNamePrefix="search-box"
                                                        isDisabled={!districtOption || districtOption.value === "ALL"}
                                                        styles={{ container: (base) => ({ ...base, width: '100%' }) }}
                                                    />
                                                </div>

                                                <div style={{
                                                    width: window.innerWidth < 768 ? '100%' : 'auto', // Full width on mobile, natural on desktop
                                                    minWidth: window.innerWidth < 768 ? 'auto' : '150px', // Min width for desktop dropdown
                                                    flexGrow: window.innerWidth < 768 ? '0' : '1', // Allow to grow on desktop
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '10px'
                                                }}>
                                                    <label style={{ fontWeight: '500', color: '#333', fontSize: '0.9em' }}>Search on</label>
                                                    <Select
                                                        options={additionalOptions}
                                                        value={additionalOption}
                                                        placeholder="Select Option"
                                                        className="search-box"
                                                        classNamePrefix="search-box"
                                                        onChange={hanldeAdditionalChange}
                                                        styles={{ container: (base) => ({ ...base, width: '100%' }) }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className=''>
                            <IonRow className=' '>
                                {/* {TempleList.length > 0 ? <> */}
                                {viewMode === 'grid' ? <>   {TempleList.map((item: any, i) => (
                                    <IonCol sizeLg='6' sizeXl='4' size-md='6' size-xs='12' size-sm='12'>
                                        <IonCard className='deity_cards'>
                                            <IonRow>
                                                <IonCol size='12'>
                                                    <IonRow style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <IonCol size='12'>
                                                            <IonText className='deity_name'>{item.templeName}</IonText>
                                                            <IonText className='deity_description MainDeity'>
                                                                <span>Main Deity</span> : {item.mainDeity}
                                                            </IonText>
                                                            <IonText className='deity_description'>
                                                                <span> Pooja Offering </span>: {item.poojaOfferings}
                                                            </IonText>
                                                        </IonCol>
                                                    </IonRow>
                                                    <IonRow style={{ marginTop: "5px" }}>
                                                        <IonButton onClick={(e) => templeDetails(item)}>
                                                            <span className='button_padding'>
                                                                Select
                                                                {/* Area */}
                                                            </span>
                                                        </IonButton>
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>
                                        </IonCard>
                                    </IonCol>
                                ))
                                }</> : <div style={{ width: "100%" }}>
                                    <CommonDataTable
                                        columns={columns}
                                        data={TempleList}
                                        loading={showLoading}
                                        noDataMessage="Sorry, No data available"
                                        onRowClick={(item: any) => templeDetails(item)}
                                    />
                                </div>}
                                {/* </> : <div className='no-materials'>
                                <IonText>Sorry, No data available</IonText>
                            </div>} */}
                            </IonRow>
                        </div>
                    </div> : index1 === 1 ? <IonGrid className='about_deity_container '>
                        <IonRow style={{ paddingTop: "20px" }}>
                            <IonCol size='1' className='center_col'>
                                <div className='back'>
                                    <IonIcon onClick={() => {
                                        setIndex1(0)
                                    }} src={arrowBack} className="point back" size="large" />
                                </div>
                            </IonCol>
                            <IonCol size='11'>
                                <IonText className='bio_deity'>
                                    Biography
                                </IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size-lg="12" size-md="12" size-xs="12">
                                <IonImg src={image} className='bio_right_img bio_deity_image' />
                                <p className='bio_deity_description'>{description}</p>
                            </IonCol>
                        </IonRow>
                    </IonGrid> :
                        index1 === 2 ?
                            <div>
                                <IonGrid className=''>
                                    <IonRow>
                                        <IonCol className='sa' size='12' sizeLg='5.5'>
                                            <form onSubmit={handleSubmit(Submit)} onKeyPress={e => SearchF(e.key)}>
                                                <IonRow>
                                                    <IonCol className='center_col' size='1'>
                                                        <div >
                                                            <IonIcon onClick={() => views()} className="point back" src={arrowBack} size="large" />
                                                        </div></IonCol>
                                                    <IonCol size='10' className='center_col'>
                                                        <div>
                                                            <IonText className='select_text'> Select Area</IonText>
                                                        </div></IonCol>
                                                </IonRow>
                                                <IonRow className='justify-ion-text-center'>
                                                    {/* <IonCol size-xs="12" size-sm="6" size-lg="6" size-md="6">
                                                    <IonLabel className='textsize'> Deity</IonLabel>
                                                </IonCol> */}
                                                    <IonCol className='inputcol' size-xs="12" size-sm="12" size-lg="12" size-md="12">
                                                        <div className='center_col'>
                                                            <IonText className='deity_text_search'>{deityName}</IonText>
                                                        </div>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='To'>
                                                    <IonCol size='12'>
                                                        <IonLabel className='search_label'> Country</IonLabel>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='Too'>
                                                    <IonCol size='12'>
                                                        <Select
                                                            className={stateMenu ? "custom-select" : "custom-select-dark"}
                                                            options={countryLiistOptions}
                                                            value={countryOption}
                                                            placeholder="Select a country"
                                                            isClearable
                                                            styles={customStyles}
                                                            onChange={handleCountryChange}
                                                        />
                                                        {formErrors.country && <span className="alert_input_bottom ">{formErrors.country}</span>}
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='To'>
                                                    <IonCol size="12" >
                                                        <IonLabel className='search_label'>State</IonLabel>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='Too'>
                                                    <IonCol size='12'>
                                                        <Select
                                                            className={stateMenu ? "custom-select" : "custom-select-dark"}
                                                            options={stateLiistOptions}
                                                            value={stateOption}
                                                            placeholder="Select a State"
                                                            isClearable
                                                            styles={customStyles}
                                                            onChange={handleStateChange}
                                                            menuIsOpen={stateMenu}
                                                            onMenuClose={() => setStateMenu(false)}
                                                            onMenuOpen={() => setStateMenu(true)}
                                                        />
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='To'>
                                                    <IonCol size='12'>
                                                        <IonLabel className='search_label'>District</IonLabel>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='Too'>
                                                    <IonCol>
                                                        <Select
                                                            className={districtMenu ? "custom-select" : "custom-select-dark"}
                                                            options={districtLiistOptions}
                                                            value={districtOption}
                                                            placeholder="Select a District"
                                                            isClearable
                                                            styles={customStyles}
                                                            onChange={handleDistrictChange}
                                                            menuIsOpen={districtMenu}
                                                            onMenuClose={() => setDistrictMenu(false)}
                                                            onMenuOpen={() => setDistrictMenu(true)}
                                                        />
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='To'>
                                                    <IonCol>
                                                        <IonLabel className='search_label'>Village / Town</IonLabel>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='Too'>
                                                    <IonCol>
                                                        <IonInput className='search_text' value={town} onIonChange={(e) => setTown(e.target.value)} />
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow style={{ display: "flex", justifyContent: "center" }}>
                                                    <div className="center"><p>
                                                        or</p></div>
                                                </IonRow>
                                                <IonRow className='To'>
                                                    <IonCol>
                                                        <IonLabel className='search_label'>Enter Temple Name </IonLabel>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow className='Too'>
                                                    <IonCol >
                                                        <IonInput className='search_text' value={temName} onIonChange={(e) => setTemName(e.target.value)} />
                                                    </IonCol>
                                                </IonRow>

                                                <div className='center_col padding_search'>
                                                    <div >
                                                        <IonButton className={Capacitor.getPlatform() === "ios" ? 'clear_all border_change_clear' : 'clear_all'} onClick={Clear}>
                                                            <span className='button_padding'> Clear All</span>

                                                        </IonButton>
                                                    </div>
                                                    <div>
                                                        <IonButton className='search_btn' type="submit">
                                                            <span className='button_padding'>Search</span>

                                                        </IonButton>
                                                    </div>
                                                </div>
                                            </form>
                                        </IonCol>
                                        {hideContent === true ? <></> :
                                            <IonCol ref={targetRef} className='oo' size='12' sizeLg='6.5'>
                                                <IonRow>
                                                    <div style={{ textAlign: "center", width: "100%", marginTop: "1%" }}>
                                                        <IonText className='deity_text_search'>Temple Name</IonText>
                                                    </div>
                                                </IonRow>
                                                <div className='temple_list_container'>
                                                    <div className='templenamescroll'>

                                                        {showgod ?
                                                            <>
                                                                {gods.length == 0 ?
                                                                    <div className='no_result'>
                                                                        <IonLabel className='before_search_text'>Not a serviceable area</IonLabel>
                                                                    </div> : gods.length != 0 ?
                                                                        <>
                                                                            <div style={{ color: "red", textAlign: "center", paddingBottom: "10px", fontSize: "14px" }}>
                                                                                <span >* Please click on one of the temples displayed in the list to proceed</span>

                                                                            </div>
                                                                            {
                                                                                gods.map((item: any, i: any) => (
                                                                                    <div className='temple_list' onClick={() => templeDetails(item.id)}>
                                                                                        <IonRow >
                                                                                            <IonCol size='2' >
                                                                                                <div className='multi-color-dot'></div>

                                                                                            </IonCol>
                                                                                            <IonCol size='10' >
                                                                                                <IonLabel
                                                                                                >{item.name}
                                                                                                </IonLabel>
                                                                                            </IonCol>


                                                                                        </IonRow></div>
                                                                                ))
                                                                            }
                                                                        </> : <></>
                                                                }
                                                            </> :
                                                            <div className='temple_bg'>
                                                                <div className='temple_budha_bg'>
                                                                </div>
                                                                <div className='search_display'>
                                                                    <IonLabel className='before_search_text'>Search Your Temple</IonLabel>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </IonCol>}
                                    </IonRow>
                                </IonGrid>
                            </div> :
                            index1 === 4 ?
                                <div className='temple_container'>
                                    <div>
                                        <IonGrid style={{ padding: '0px' }}>
                                            <IonRow>
                                                <IonCol size-lg="3.5" size-md="3.5" size-sm="12" size-xs="12" className='menu_show'>
                                                    <IonRow>
                                                        <IonCol size-lg="5" size-xs='4' className='temple_back' >
                                                            <IonIcon onClick={() => back1()} className='back' src={arrowBack} size="large"></IonIcon>
                                                        </IonCol>
                                                    </IonRow>
                                                    <div className='temple_menu' >

                                                        <div>
                                                            <div>
                                                                <IonImg className='img_class' src={deityImg + "?v=" + new Date()}>
                                                                </IonImg>
                                                                <IonLabel className='deity_style'>{deityName}</IonLabel>
                                                            </div>
                                                        </div>
                                                        <div className={index == 0 ? "selected-btn" : "menu-btn"} id="0" onClick={getBtnId}>
                                                            <IonLabel id="0" onClick={getBtnId} >
                                                                About
                                                            </IonLabel>
                                                        </div>
                                                        <div className={index == 1 ? "selected-btn" : "menu-btn"} id="1" onClick={getBtnId}>
                                                            <IonLabel id="1" onClick={getBtnId} >
                                                                Facilities
                                                            </IonLabel>
                                                        </div>
                                                        <div className={index == 2 ? "selected-btn" : "menu-btn"} id="2" onClick={getBtnId}>
                                                            <IonLabel id="2" onClick={getBtnId}>
                                                                Offerings & Significance
                                                            </IonLabel>
                                                        </div>
                                                        <div className={index == 3 ? "selected-btn" : "menu-btn"} id="3" onClick={getBtnId}>
                                                            <IonLabel id="3" onClick={getBtnId}>
                                                                Festivals
                                                            </IonLabel>
                                                        </div>
                                                        <div className={index == 4 ? "selected-btn" : "menu-btn"} id="4" onClick={getBtnId}>
                                                            <IonLabel id="4" onClick={getBtnId}>
                                                                Pooja List
                                                            </IonLabel>
                                                        </div>
                                                        <div className={index == 5 ? "selected-btn" : "menu-btn"} id="5" onClick={getBtnId}>
                                                            <IonLabel id="5" onClick={getBtnId}>
                                                                Aerial View
                                                            </IonLabel>
                                                        </div>
                                                        <div className={index == 6 ? "selected-btn" : "menu-btn"} id="6" onClick={getBtnId}>
                                                            <IonLabel id="6" onClick={getBtnId}>
                                                                Schedule & Timings
                                                            </IonLabel>
                                                        </div>
                                                        <div className={index == 7 ? "selected-btn" : "menu-btn"} id="7" onClick={getBtnId} style={{ borderBottom: "none" }}>
                                                            <IonLabel id="7" onClick={getBtnId}>
                                                                Gallery
                                                            </IonLabel>
                                                        </div></div>
                                                </IonCol>
                                                <IonCol size-lg="8.5" size-md="8.5" size-sm="12" size-xs="12" className="menu-col details-col">
                                                    <IonRow>
                                                        <IonCol size-lg="1" size-md="1" size-sm="2" size-xs="2" className="menu_back center_col">
                                                            <IonIcon onClick={() => back1()} className='back' src={arrowBack} size="large"></IonIcon>
                                                        </IonCol>

                                                        <IonCol size-md="12" size-sm="8" size-xs="8" size-lg="12" >
                                                            <div className="grid"> <IonText className='header_style'>{aerial.name}</IonText></div>

                                                        </IonCol>
                                                        <IonCol size-lg="1" size-md="1" size-sm="2" size-xs="2" className="menu_pop center_col">

                                                            <IonIcon
                                                                className="menu_pop"
                                                                src={ellipsisVerticalCircleOutline}
                                                                size="large"
                                                                style={{ cursor: "pointer" }}
                                                                id="menu_content"
                                                                color="primary"
                                                            ></IonIcon>
                                                            <IonPopover
                                                                trigger="menu_content"
                                                                dismissOnSelect={true}
                                                                show-backdrop={false}
                                                            >
                                                                <IonContent style={{ background: "white" }} scrollEvents={true}>
                                                                    <IonList className='templeTabBtnMainCls'>
                                                                        <div className={index == 0 ? "selected-btn" : "menu-btn"} id="0" onClick={getBtnId}>
                                                                            <IonLabel id="0" onClick={getBtnId} >
                                                                                About
                                                                            </IonLabel>
                                                                        </div>
                                                                        <div className={index == 1 ? "selected-btn" : "menu-btn"} id="1" onClick={getBtnId}>
                                                                            <IonLabel id="1" onClick={getBtnId}>
                                                                                Facilities
                                                                            </IonLabel>
                                                                        </div>
                                                                        <div className={index == 2 ? "selected-btn" : "menu-btn"} id="2" onClick={getBtnId}>
                                                                            <IonLabel id="2" onClick={getBtnId}>
                                                                                Offerings & Significance
                                                                            </IonLabel>
                                                                        </div>
                                                                        <div className={index == 3 ? "selected-btn" : "menu-btn"} id="3" onClick={getBtnId}>
                                                                            <IonLabel id="3" onClick={getBtnId}>
                                                                                Festivals
                                                                            </IonLabel>
                                                                        </div>
                                                                        <div className={index == 4 ? "selected-btn" : "menu-btn"} id="4" onClick={getBtnId}>
                                                                            <IonLabel id="4" onClick={getBtnId}>
                                                                                Pooja List
                                                                            </IonLabel>
                                                                        </div>
                                                                        <div className={index == 5 ? "selected-btn" : "menu-btn"} id="5" onClick={getBtnId}>
                                                                            <IonLabel id="5" onClick={getBtnId}>
                                                                                Aerial View
                                                                            </IonLabel>
                                                                        </div>

                                                                        <div className={index == 6 ? "selected-btn" : "menu-btn"} id="6" onClick={getBtnId} >
                                                                            <IonLabel id="6" onClick={getBtnId}>
                                                                                Schedule & Timings
                                                                            </IonLabel>
                                                                        </div>
                                                                        <div className={index == 7 ? "selected-btn" : "menu-btn"} id="7" onClick={getBtnId} style={{ borderBottom: "none" }}>
                                                                            <IonLabel id="7" onClick={getBtnId}>
                                                                                Gallery
                                                                            </IonLabel>
                                                                        </div>
                                                                    </IonList>
                                                                </IonContent>
                                                            </IonPopover>

                                                        </IonCol>


                                                    </IonRow>
                                                    {index == 0 ? <div>
                                                        <div className="grid">
                                                            <IonGrid>
                                                                <IonRow>
                                                                    <IonCol size-lg="12" size-md="12" size-xs="12">
                                                                        {gallery.length > 0 ? <div>
                                                                            <img src={gallery[0]} className='rightImage templeImage' />
                                                                        </div> : <></>}
                                                                        <p className='history_style'>{aerial.aboutAndHistory}</p>

                                                                    </IonCol>
                                                                    {/* <IonCol size-lg="3" size-md="4" size-xs="5"> */}

                                                                    {/* </IonCol> */}
                                                                </IonRow>
                                                            </IonGrid>
                                                        </div>
                                                    </div> : index == 1 ? <div>
                                                        <div className='facility_container'>
                                                            <IonGrid className="grid">
                                                                <IonRow>
                                                                    <IonCol size-lg="12" size-md="12" size-xs="12">
                                                                        <IonGrid>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Parking Lot
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {facilities.parkingLot === "" ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        : <IonText className='facility_text'>
                                                                                            {facilities.parkingLot}
                                                                                        </IonText>}

                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Security
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {facilities.security === "" ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        :
                                                                                        <IonText className='facility_text'>
                                                                                            {facilities.security}
                                                                                        </IonText>}
                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Restrooms
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {facilities.restRooms === "" ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        :
                                                                                        <IonText className='facility_text'>
                                                                                            {facilities.restRooms}
                                                                                        </IonText>}
                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Cloak Counters
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {facilities.cloakCounters === "" ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        :
                                                                                        <IonText className='facility_text'>
                                                                                            {facilities.cloakCounters}
                                                                                        </IonText>}
                                                                                </IonCol>
                                                                            </IonRow>

                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Pooja Provisions
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {facilities.poojaProvisions === "" ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        :
                                                                                        <IonText className='facility_text'>
                                                                                            {facilities.poojaProvisions}
                                                                                        </IonText>}
                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Shop
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {shop.length === 0 ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        :
                                                                                        <>
                                                                                            {
                                                                                                shop.map((item: any, i: any) => {
                                                                                                    console.log(item)
                                                                                                    return (
                                                                                                        <>

                                                                                                            <IonText className='facility_text' id={i}>
                                                                                                                {item} {i != (shop.length - 1) && <>,</>}
                                                                                                            </IonText>
                                                                                                        </>
                                                                                                    );
                                                                                                })
                                                                                            }
                                                                                        </>}
                                                                                </IonCol>


                                                                            </IonRow>


                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Cab / Auto Availability
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {facilities.cabAvailablity === "" ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        :
                                                                                        <IonText className='facility_text'>
                                                                                            {facilities.cabAvailablity}
                                                                                        </IonText>}
                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Auditorium
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    {facilities.auditorium === "" ?
                                                                                        <IonText className='facility_text'>
                                                                                            N/A
                                                                                        </IonText>
                                                                                        :
                                                                                        <IonText className='facility_text'>
                                                                                            {facilities.auditorium}
                                                                                        </IonText>}
                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Car
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    <IonText className='facility_text'>
                                                                                        {car}
                                                                                    </IonText>

                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Bus
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    <IonText className='facility_text'>
                                                                                        {bus}
                                                                                    </IonText>

                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Train
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    <IonText className='facility_text'>
                                                                                        {train}
                                                                                    </IonText>

                                                                                </IonCol>
                                                                            </IonRow>
                                                                            <IonRow className="remove-border">
                                                                                <IonCol size="2" className='tick_container' >
                                                                                    <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                                    </IonIcon>
                                                                                </IonCol>
                                                                                <IonCol size="5.5"  >
                                                                                    <IonText className='facility_text'>
                                                                                        Flight
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size='0.5'>
                                                                                    <IonText className='facility_text'>
                                                                                        :
                                                                                    </IonText>
                                                                                </IonCol>
                                                                                <IonCol size="4" >
                                                                                    <IonText className='facility_text'>
                                                                                        {flight}
                                                                                    </IonText>

                                                                                </IonCol>
                                                                            </IonRow>



                                                                        </IonGrid>
                                                                    </IonCol>
                                                                </IonRow>
                                                            </IonGrid>
                                                        </div>
                                                    </div> : index == 2 ? <div>
                                                        <IonGrid className="grid">
                                                            {nodata == true ? <div style={{ height: "350px", width: "100%", display: "flex", justifyContent: "center" }}>
                                                                <IonText style={{ display: "flex", alignItems: "center", color: "black" }}>No Data Available</IonText>

                                                            </div> :
                                                                <div>
                                                                    {Offerings.map((item: any) => (
                                                                        <div>
                                                                            {(item.offeringName === "" || item.offeringName === null) && (item.significance == "" || item.significance === null) ?
                                                                                <div>
                                                                                </div> : <div>
                                                                                    <IonRow>
                                                                                        <IonText className='offering_head'>{item.offeringName} :</IonText>
                                                                                    </IonRow>
                                                                                    <IonRow >
                                                                                        <p className='offering_style'>&emsp; &emsp; &emsp;{item.significance}</p>
                                                                                    </IonRow>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    ))}</div>}
                                                        </IonGrid>
                                                    </div> : index == 3 ? <div>
                                                        <IonGrid className="grid">
                                                            {nodataFest == true ? <div style={{ height: "350px", width: "100%", display: "flex", justifyContent: "center" }}>
                                                                <IonText style={{ display: "flex", alignItems: "center", color: "black" }}>No Data Available</IonText>

                                                            </div> :
                                                                <div>
                                                                    {festival.map((item: any) => (
                                                                        <div>
                                                                            {(item.name == "" || item.name === null) && (item.description == "" || item.description == null) ? <div></div> :
                                                                                <div>
                                                                                    <IonRow>
                                                                                        <IonText className='offering_head'>{item.name} :</IonText>
                                                                                    </IonRow>
                                                                                    <IonRow>
                                                                                        <p className='offering_style'>&emsp; &emsp; &emsp; {item.description}</p>
                                                                                    </IonRow>
                                                                                </div>}
                                                                        </div>
                                                                    ))}</div>}

                                                        </IonGrid>
                                                    </div> : index == 4 ? <div>
                                                        <IonGrid className="grid">
                                                            <IonRow>
                                                                <IonText className='offering_head'>Pooja List</IonText>
                                                            </IonRow>
                                                            <IonRow className='pooja_tab'>
                                                                <IonCol className="table_column1">
                                                                    <IonGrid className='table_container'>

                                                                        <IonRow className="row_head">
                                                                            <IonCol size='1' className="head-border">
                                                                                S.no
                                                                            </IonCol>
                                                                            <IonCol size='3.5' className="head-border">
                                                                                Name of Vazhipadu
                                                                            </IonCol>
                                                                            <IonCol size='4' className="head-border">
                                                                                Description
                                                                            </IonCol>
                                                                            <IonCol size='1.5' className="head-border">
                                                                                Rate
                                                                            </IonCol>
                                                                            <IonCol size='2' className="head-border">
                                                                                Deity
                                                                            </IonCol>
                                                                        </IonRow>
                                                                        {
                                                                            poojaoffer.map((item: any, i: any) => (
                                                                                <IonRow className="row_col">
                                                                                    <IonCol size='1' className="row_first col_border">{i + 1}</IonCol>
                                                                                    <IonCol size='3.5' className="col_border">{item.name}</IonCol>
                                                                                    <IonCol size='4' className="col_border">{item.description}</IonCol>
                                                                                    <IonCol size='1.5' className="col_border">&#8377; {item.price}</IonCol>
                                                                                    <IonCol size='2' className='col_last'>{item.deity.deityName}</IonCol>
                                                                                </IonRow>
                                                                            ))}


                                                                    </IonGrid>
                                                                </IonCol>
                                                            </IonRow>
                                                            <div className='menu_back'>
                                                                {
                                                                    poojaoffer.map((item: any, i: any) => (
                                                                        <IonCard className='pooja_card'>
                                                                            <IonRow>
                                                                                <IonCol className="pooja_col" size='5'>
                                                                                    {i + 1}. Vazhipadu
                                                                                </IonCol>
                                                                                <IonCol className="pooja_col" size='0.5' >:</IonCol>
                                                                                <IonCol className="pooja_col" size='6.5'>
                                                                                    {item.name}
                                                                                </IonCol>


                                                                            </IonRow>
                                                                            <IonRow>
                                                                                <IonCol className="pooja_col" size='5'>
                                                                                    Description
                                                                                </IonCol>
                                                                                <IonCol className="pooja_col" size='0.5' >:</IonCol>
                                                                                <IonCol className="pooja_col" size='6.5'>
                                                                                    {item.description}
                                                                                </IonCol>


                                                                            </IonRow>
                                                                            <IonRow>
                                                                                <IonCol size='5' className="pooja_col">
                                                                                    Rate
                                                                                </IonCol>
                                                                                <IonCol size='0.5' className="pooja_col">:</IonCol>
                                                                                <IonCol size='6.5' className="pooja_col">
                                                                                    &#8377; {item.price}
                                                                                </IonCol>


                                                                            </IonRow>
                                                                            <IonRow>
                                                                                <IonCol size='5' className="pooja_col">
                                                                                    Deity
                                                                                </IonCol>
                                                                                <IonCol size='0.5' className="pooja_col">:</IonCol>
                                                                                <IonCol size='6.5' className="pooja_col">
                                                                                    {item.deity.deityName}
                                                                                </IonCol>


                                                                            </IonRow>
                                                                        </IonCard>))}
                                                            </div>

                                                        </IonGrid>
                                                    </div> : index == 5 ? <div>
                                                        <div>
                                                            <IonGrid className="grid">
                                                                <IonRow>
                                                                    <IonCol size-lg="12" size-md="12" size-xs="12" size-sm="12">

                                                                        <div className='parent'>
                                                                            {window.google == undefined ? <LoadScript
                                                                                googleMapsApiKey={UserService.mapKey()}
                                                                            >
                                                                                <GoogleMap
                                                                                    mapContainerClassName="containerStyle"
                                                                                    center={center}
                                                                                    zoom={15} options={mapOption}
                                                                                >
                                                                                    <MarkerF position={center} />
                                                                                </GoogleMap>
                                                                            </LoadScript> : <GoogleMap
                                                                                mapContainerClassName="containerStyle"
                                                                                center={center}
                                                                                zoom={15} options={mapOption}
                                                                            >
                                                                                <MarkerF position={center} />
                                                                            </GoogleMap>}
                                                                            <div className='child'>
                                                                                <IonButton className='map_share' onClick={openMap}>Share
                                                                                    <IonIcon src={shareSocialSharp} className='share_icon' />
                                                                                </IonButton>
                                                                            </div>

                                                                        </div>
                                                                    </IonCol>
                                                                </IonRow>
                                                            </IonGrid>
                                                        </div>
                                                    </div> : index == 6 ? <div>
                                                        <div style={{ padding: "2%" }} className="grid">

                                                            <IonRow>
                                                                <IonText className='offering_head'>Schedule & Timings</IonText>
                                                            </IonRow>

                                                            <div className='schedule_container'>
                                                                <IonGrid>
                                                                    <IonRow className="remove-border">
                                                                        <IonCol size="1" className='tick_container' >
                                                                            <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                            </IonIcon>
                                                                        </IonCol>
                                                                        <IonCol size="4"  >
                                                                            <IonText className='facility_text'>
                                                                                Morning Darsan
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size='0.5'>
                                                                            <IonText className='facility_text'>
                                                                                :
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size="6.5" >
                                                                            <IonText className='facility_text'>
                                                                                {morning}
                                                                            </IonText>

                                                                        </IonCol>
                                                                    </IonRow>
                                                                    <IonRow className="remove-border">
                                                                        <IonCol size="1" className='tick_container' >
                                                                            <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                            </IonIcon>
                                                                        </IonCol>
                                                                        <IonCol size="4"  >
                                                                            <IonText className='facility_text'>
                                                                                Evening Darsan
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size='0.5'>
                                                                            <IonText className='facility_text'>
                                                                                :
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size="6.5" >
                                                                            <IonText className='facility_text'>
                                                                                {evening}
                                                                            </IonText>

                                                                        </IonCol>
                                                                    </IonRow>

                                                                    <IonRow className="remove-border">
                                                                        <IonCol size="1" className='tick_container' >
                                                                            <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                            </IonIcon>
                                                                        </IonCol>
                                                                        <IonCol size="4"  >
                                                                            <IonText className='facility_text'>
                                                                                Time Required
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size='0.5'>
                                                                            <IonText className='facility_text'>
                                                                                :
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size="6.5" >
                                                                            <IonText className='facility_text'>
                                                                                {timerequ}
                                                                            </IonText>

                                                                        </IonCol>
                                                                    </IonRow>
                                                                    <IonRow className="remove-border">
                                                                        <IonCol size="1" className='tick_container' >
                                                                            <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                            </IonIcon>
                                                                        </IonCol>
                                                                        <IonCol size="4"  >
                                                                            <IonText className='facility_text'>
                                                                                Closing Timings
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size='0.5'>
                                                                            <IonText className='facility_text'>
                                                                                :
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size="6.5" >
                                                                            <IonText className='facility_text'>
                                                                                {closetime}
                                                                            </IonText>

                                                                        </IonCol>
                                                                    </IonRow>
                                                                    <IonRow className="remove-border">
                                                                        <IonCol size="1" className='tick_container' >
                                                                            <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                            </IonIcon>
                                                                        </IonCol>
                                                                        <IonCol size="4"  >
                                                                            <IonText className='facility_text'>
                                                                                Fees Details
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size='0.5'>
                                                                            <IonText className='facility_text'>
                                                                                :
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size="6.5" >
                                                                            <IonText className='facility_text'>
                                                                                {entry}
                                                                            </IonText>

                                                                        </IonCol>
                                                                    </IonRow>
                                                                    <IonRow className="remove-border">
                                                                        <IonCol size="1" className='tick_container' >
                                                                            <IonIcon className='tick' src={checkmarkCircleSharp} >

                                                                            </IonIcon>
                                                                        </IonCol>
                                                                        <IonCol size="4"  >
                                                                            <IonText className='facility_text'>
                                                                                Dress Code
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size='0.5'>
                                                                            <IonText className='facility_text'>
                                                                                :
                                                                            </IonText>
                                                                        </IonCol>
                                                                        <IonCol size="6.5" >
                                                                            <IonText className='facility_text'>
                                                                                Men - {dressme}
                                                                            </IonText><br />
                                                                            <IonText className='facility_text'>
                                                                                Women - {dresswo}
                                                                            </IonText>

                                                                        </IonCol>
                                                                    </IonRow>



                                                                    <IonRow>
                                                                        <IonCol size-lg="3" size-md="3" size="5">
                                                                            <IonLabel style={{ fontSize: "14px", fontWeight: "bold" }}></IonLabel>
                                                                        </IonCol>
                                                                        <IonCol size-lg="9" size-md="9" size="7">
                                                                            <IonText></IonText>
                                                                            <IonText></IonText>
                                                                        </IonCol>
                                                                    </IonRow>
                                                                </IonGrid>
                                                            </div>
                                                        </div>
                                                    </div> : index == 7 ? <div>
                                                        <div className="grid">
                                                            <IonGrid>
                                                                <IonRow className="ion-justify-content-center">
                                                                    {gallery.map((item: any, i: any) => {
                                                                        return (
                                                                            <IonCol size-lg="4" size-md="4" size-xs="12">
                                                                                <IonCard className='img-card'>
                                                                                    <IonImg src={item} style={{ cursor: "pointer" }} onClick={() => openModalAndSetIndex(i)} className="img" tabIndex={1}
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                openModalAndSetIndex(i)
                                                                                            }
                                                                                        }} />
                                                                                </IonCard>
                                                                            </IonCol>
                                                                        )
                                                                    })}
                                                                    {showModal && (
                                                                        <Lightbox
                                                                            mainSrc={gallery[indexOfImages]}
                                                                            nextSrc={gallery.length > 1 ? gallery[(indexOfImages + 1) % gallery.length] : undefined}
                                                                            prevSrc={
                                                                                gallery.length > 1 ? gallery[
                                                                                    (indexOfImages + gallery.length - 1) % gallery.length
                                                                                ] : undefined
                                                                            }
                                                                            onCloseRequest={() => setShowModal(false)}
                                                                            onImageLoad={() => {
                                                                                window.dispatchEvent(new Event('resize'));
                                                                            }}
                                                                            onMovePrevRequest={() =>
                                                                                setIndexOfImages(
                                                                                    (indexOfImages + gallery.length - 1) % gallery.length
                                                                                )
                                                                            }
                                                                            onMoveNextRequest={() =>
                                                                                setIndexOfImages(
                                                                                    (indexOfImages + gallery.length + 1) % gallery.length
                                                                                )
                                                                            }
                                                                        />
                                                                    )}
                                                                </IonRow>

                                                                <IonRow style={{ paddingTop: "25px" }}>
                                                                    <IonText className='offering_head'>Video Link</IonText>
                                                                </IonRow>
                                                                <div>
                                                                    {videolinkshow === true ? <div style={{ marginTop: "2%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                        <IonText style={{ color: "black" }}>
                                                                            No Data Available
                                                                        </IonText>
                                                                    </div> : <div>
                                                                        {videolink.map((item: any) => {
                                                                            console.log(item)
                                                                            return (<>
                                                                                {item.videoName.length > 0 ? <>
                                                                                    <div className='video_link'>
                                                                                        <IonText >{item.videoName}</IonText>
                                                                                    </div>
                                                                                    <div className="live_link">

                                                                                        <a style={{ color: '#13ACFF' }} href={item.videoLink} target='_blank'>{item.videoLink}</a>

                                                                                    </div>

                                                                                </> : <>
                                                                                </>}
                                                                            </>
                                                                            )
                                                                        }
                                                                        )}</div>}
                                                                </div>
                                                                <div>
                                                                    <IonRow style={{ paddingTop: "40px" }}>
                                                                        <IonText className='offering_head'>Live Video Link</IonText>
                                                                    </IonRow>
                                                                    {livevideolinkshow === true ? <div style={{ marginTop: "2%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                        <IonText style={{ color: "black" }}>
                                                                            No Data Available
                                                                        </IonText></div> : <div>
                                                                        {videolivelink.map((item: any) => {
                                                                            console.log(item)
                                                                            return (<>
                                                                                {item.videoName.length > 0 ? <>
                                                                                    <div className='video_link'>

                                                                                        <IonText >{item.videoName}</IonText>
                                                                                    </div>
                                                                                    <div className='live_link'>
                                                                                        <a style={{ color: '#13ACFF' }} href={item.videoLink} target='_blank'>{item.videoLink}</a>
                                                                                    </div>
                                                                                </> : <>
                                                                                </>}
                                                                            </>
                                                                            )
                                                                        }
                                                                        )}</div>}
                                                                </div>
                                                            </IonGrid>
                                                        </div>
                                                    </div> : <div></div>}
                                                </IonCol>
                                            </IonRow>
                                            {index == 0 &&
                                                <IonRow>
                                                    <IonCol size-lg="12" size-md="12" size-xs="12" size-sm="12" style={{ padding: "0px" }}>

                                                        <div className='parent'>
                                                            {window.google == undefined ? <LoadScript
                                                                googleMapsApiKey={UserService.mapKey()}
                                                            >
                                                                <GoogleMap
                                                                    mapContainerClassName="containerStyle"
                                                                    center={center}
                                                                    zoom={15} options={mapOption}
                                                                >
                                                                    <MarkerF position={center} />
                                                                </GoogleMap>
                                                            </LoadScript> : <GoogleMap
                                                                mapContainerClassName="containerStyle"
                                                                center={center}
                                                                zoom={15} options={mapOption}
                                                            >
                                                                <MarkerF position={center} />
                                                            </GoogleMap>}
                                                            <div className='child'>
                                                                <IonButton className='map_share' onClick={openMap}>Share
                                                                    <IonIcon src={shareSocialSharp} className='share_icon' />
                                                                </IonButton>
                                                            </div>

                                                        </div>


                                                    </IonCol>
                                                </IonRow>}
                                        </IonGrid>
                                    </div>
                                </div> : index1 === 3 ?
                                    <div className='temple_container'>
                                        {/* <IonRow className="image-description-container">
                                            <IonCol size-lg='3' size-md="3" size-xs="12" size-sm="12" className='img_centered'>
                                                {(deityImg !== "" && deityImg !== null) && <IonImg src={deityImg + "?v=" + new Date()} className='temple-image' alt="Temple 1" />}
                                            </IonCol>
                                            <IonCol size-lg='6' size-md="6" size-xs="12" size-sm="12" className="description-container">
                                                <h2 className="temple-name">{temName}</h2>
                                                <p className="temple-description">
                                                </p>
                                            </IonCol>
                                            {gallery.length > 0 ?
                                                <IonCol size-lg='3' size-md="3" size-xs="12" size-sm="12" className='img_centered'>
                                                    <IonImg src={gallery[0]} className='temple-image' />
                                                </IonCol> : <></>}
                                        </IonRow> */}
                                        <IonGrid className='tab_parent_div'>
                                            <TempleComponent id={tempcode} isUserSide={true} isedit={true} goBack={goback} />
                                        </IonGrid>
                                    </div> :
                                    <></>}</div >
                <CommonModal showModal={Commonmodal} closeModal={modalClose} modaltitle={Commmonmodaltitle} AlertModalMesg={CommonModalMesg} />
            </IonContent >
            <Foot />
        </IonPage >
    )
}
export default Temples;

